export default {
  one: "one",
  two: "two",
  three: "three",
  four: "four",
  five: "five",
  six: "six",
  seven: "seven",
  eight: "eight",
  nine: "nine",
  ten: "ten",
  "index_nihao": "Hello,{0}",
  "index_jipiao": "Tickets",
  "index_jiudianzhusu": "Hotels",
  "index_huoche": "Trains",
  "index_lvyoudujia": "Tours",
  "index_shangwuyonche": "Car Rentals",
  "index_jinqixingcheng": "Recent itinerary",
  "index_zhi": "To",
  "index_jian": "Rooms",
  "index_qushenpi": "Approve",
  "index_xiangqing": "Detail",
  "index_jiantizhongwen": "Simplified Chinese",
  "index_jijiangchengxian": "Coming soon",
  "index_ditugongnengkaifazhong": "Map functions in development",
  "index_jiudian": "Hotels",
  "index_huochepiao": "Trains",
  "index_yuyan": "Language",
  "index_jinqimeiyouchuxinganpai":"There are no plans for travel in the near future!",
	"index_meiyoushenpidingdan":"There are no orders that require approval!",

  "login_qingtianxiemima": "Please enter your password!",
  "login_wangjimima": "Forgot Password",
  "login_qingshuruyanzhengma": "Please enter the verification code",
  "login_fasongyanzhengma": "Resend verification code",
  "login_denglu": "Sign In",
  "login_yanzhengmadenglu": "Sign In by verification code",
  "login_zhanghaomimadenglu": "Sign In with account names and passwords",
  "login_jiantizhongwen": "简体中文",
	"login_yingwen": "English",
	"login_riyu": "日本語",
  "login_denglujidaibiaonintongyiwomende": "By proceeding, I acknowledge that I have read and agree to our",
  "login_tongyi": "Agree",
	"login_butongyituichuapp": "Disagree and exit the APP",
  "login_fuwuxieyi": "Terms of Use",
  "login_fuwuxieyitext": "Terms of Use",
  "login_he": "And",
  "login_byyzzbbhsyyhdgrysq": "This application respects and protects the personal privacy rights of all users.",
	"login_wlgntggzq": "To provide you with more accurate",
	"login_gygxhdfw": "More personalized services",
	"login_keyuedu": "Readable",
	"login_byyhazyszcdgdsyhplndgrxx": "This application will use and disclose your personal information in accordance with the privacy policy.",
  "login_yinsizhengce": "Privacy Statement",
	"login_yinsizhengcetext": "Privacy Statement",
  "mall_flight_backtorule_fanhui": "Back",
  "mall_flight_backtorule_tuigaiguize": "Policies",
  "mall_flight_backtorule_goupiaoxuzhi": "Ticket Notice",
  "mall_flight_backtorule_nulihuoquzhong": "Processing",
  "mall_flight_flight_chufadi": "Departure",
  "mall_flight_flight_mudedi": "Arrival",
  "mall_flight_flight_chufashijian": "Depart time",
  "mall_flight_flight_fanchengshijian": "Return time",
  "mall_flight_flight_cangwei": "Class",
  "mall_flight_flight_tianjialvke": "Add passenger",
  "mall_flight_flight_dianjixuanzelvke": "Click to select the passenger",
  "mall_flight_flight_dianjixuanzecangwei": "Click to select the shipping space",
  "mall_flight_flight_sousuo": "Search",
  "mall_flight_flight_ruxuyudingertongyingerpiaoqinglianxibengongsikefu": "If you want to book infant ticket ro child ticket, please contact our customer service",
  "mall_flight_flight_toudengcang": "First",
  "mall_flight_flight_shangwucang": "Business",
  "mall_flight_flight_jingjicang": "Economy",
	"mall_flight_flight_chaojijingjicang": "super economy class",
  "mall_flight_flight_dancheng": "One-way",
  "mall_flight_flight_wangfan": "Round-trip",
  "mall_flight_flight_shanghai": "Shanghai",
  "mall_flight_flight_beijing": "Beijing",
  "mall_flight_flight_guangzhou": "Guangzhou",
  "mall_flight_flight_yueri": "MM-DD",
  "mall_flight_flight_qingxuanzelvke": "Please select the passenger",
  "mall_flight_flight_shenpidanhangcheng": "To arrive at the destination city, there must be an approved itinerary for the flight!",
  "mall_flight_flight_shenpidanchufariqi": "The departure date must fall within the date range specified in the approval form!",
  "mall_flight_flight_shenpidanchufadaoda": "The return date must fall within the approved date range!",
  "mall_flight_flight_shenpidanmudichengshi": "The destination city must have the approval form for the entire journey!",
	"mall_flight_flight_lvkexinxiqueren": "Passenger Information Confirmation",
	"mall_flight_flight_lvkexinming": "Passenger Name",
	"mall_flight_flight_lvkezhengjian": "Passenger ID",
  "mall_flight_flight_youxiaoqizhi": "Valid until",
  "mall_flight_flight_kvkexingbie": "Passenger Sex",
	"mall_flight_flight_chushengriqi": "Date of Birth",
  "mall_flight_flight_lvkeguoji": "Passenger nationality",
	"mall_flight_flight_fanhuixiugai": "Return to modify",
  "mall_flight_flight_querenwuwu": "Confirm",
  "mall_flight_flight_xiangqing": "Details",
  "mall_flight_flightchangeinfos_gaiqian": "Change",
  "mall_flight_flightchangeinfos_yuanhangbanxinxi": "Original flight information",
  "mall_flight_flightchangeinfos_di": "The",
  "mall_flight_flightchangeinfos_cheng": "Trip",
  "mall_flight_flightchangeinfos_yueri": "MM-DD",
  "mall_flight_flightchangeinfos_tuigaiguize": "Policies",
  "mall_flight_flightchangeinfos_xinhangbanxinxi": "New flight information",
  "mall_flight_flightchangeinfos_chuhangrenxinxi": "Passenger info",
  "mall_flight_flightchangeinfos_shouji": "Mobile",
  "mall_flight_flightchangeinfos_shenfenzheng": "ID number",
  "mall_flight_flightchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun": "Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
  "mall_flight_flightchangeinfos_zongji": "Total",
  "mall_flight_flightchangeinfos_mingxi": "Details",
  "mall_flight_flightchangeinfos_tijiaoshenhe": "Submit trip approval",
  "mall_flight_flightchangeinfos_woyaogaibianhangchengbuxiangfeiliao": "I want to change the schedule",
  "mall_flight_flightchangeinfos_jicuohangchengriqishijianxingming": "Forgot the itinerary, date, time or name",
  "mall_flight_flightchangeinfos_hangbanyanwuhuoquxiao": "Flight delay or cancellation",
  "mall_flight_flightchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin": "According to your company's trip rule, please select the reason of change",
  "mall_flight_flightchangeinfos_gongxinintijiaochenggongqingnaixindengdaikefuhejia": "Submitted successfully. Please be patient and wait customer service account the price",
  "mall_flight_flightchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie": "The order can't be changed now. Please contact the customer service, thank you.",
  "mall_flight_flightdetails_hangbanxiangqing": "Flight Details",
  "mall_flight_flightdetails_zhifei": "Nonstop",
  "mall_flight_flightdetails_yueri": "MM-DD",
  "mall_flight_flightdetails_yixiafeiyongjunweichengrenhuoertonghuoyingerderenjunjia": "The following charge is the average price of an adult or a child or an infant.",
  "mall_flight_flightdetails_shangwutuijian": "Business Recommendation",
  "mall_flight_flightdetails_baoxian": "Insurance+¥{0}",
  "mall_flight_flightdetails_jinsheng": "Only{0}",
  "mall_flight_flightdetails_zhang": "Tickets",
  "mall_flight_flightdetails_tuigaiguize": "Policies",
  "mall_flight_flightdetails_weibeiguize": "Violating rules",
  "mall_flight_flightdetails_fuheguize": "Conforming rules",
  "mall_flight_flightdetails_ding": "Book",
  "mall_flight_flightdetails_tuipiaozhongkai": "Refund and book new one",
  "mall_flight_flightdetails_tuigaishiduan": "Prior to departure ",
  "mall_flight_flightdetails_tuipiaofeiyong": "REFUND FEE",
  "mall_flight_flightdetails_gaiqianfeiyong": "CHANGE FEE",
  "mall_flight_flightdetails_qian": "Before",
  "mall_flight_flightdetails_ren": "￥{0}/per",
  "mall_flight_flightdetails_hanglie": "Baggage Allowance",
  "mall_flight_flightdetails_yihangkonggongsizuixinguidingweizhunkezixunkefudianhua": "Determined by the airline. Please contact the customer service",
  "mall_flight_flightdetails_yscrtgqgzjfybzjgcksj": "Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
  "mall_flight_flightdetails_tuigaiguizeyihangsishenheweizhun": "Cancellation and change policies are based on the airline",
  "mall_flight_flightdetails_yudingtuijianhangban": "Book a low price flight",
	"mall_flight_flightdetails_jixuyudingyuanhangban": "Book the original flight",
	"mall_flight_flightdetails_gjgsclzctjnyddjhb": "According to the company's travel policy, we recommend you to book a low-cost flight",
  "mall_flight_flightdetails_weibei": "Violate",
  "mall_flight_flightdetails_qingyihangsishenheweizhun": "Please subject to the airline's review",
  "mall_flight_flightdetails_gaihangbanweiyinbeiguizebukeyuding": "You can't book this flight according to the rules",
  "mall_flight_flightdetails_nsyddxyjgxytqbàcngsy": "The ticket you book should be filed on record before use. Please contact with 4000888020, thank you",
  "mall_flight_flightdetails_zhe": "",
  "mall_flight_flightlist_zhongzhuan": "Transit",
  "mall_flight_flightlist_jinsheng": "Only{0}",
  "mall_flight_flightlist_zhang": "Tickets",
  "mall_flight_flightlist_chongzu": "Enough",
  "mall_flight_flightlist_jingting": "Stopover",
  "mall_flight_flightlist_weibeiguize": "Violate rules",
  "mall_flight_flightlist_fuheguize": "Conforming rules",
  "mall_flight_flightlist_jiazaizhong": "Processing",
  "mall_flight_flightlist_shanghai": "Shanghai",
  "mall_flight_flightlist_beijing": "Beijing",
  "mall_flight_flightlist_dengdai": "({time} in {city})",
  "mall_flight_flightorder_zhifei": "Non-stop",
  "mall_flight_flightorder_yueri": "MM-DD",
  "mall_flight_flightorder_piaojia": "Price",
  "mall_flight_flightorder_yuan": "{0}CNY",
  "mall_flight_flightorder_jijianranyou": "Airport construction fee",
  "mall_flight_flightorder_yuanren": "CNY",
  "mall_flight_flightorder_baoxian": "Insurance",
  "mall_flight_flightorder_hangbanxiangqing": "Flight Details",
  "mall_flight_flightorder_xuanzechuhangren": "Select the passenger",
  "mall_flight_flightorder_qingheduidingdanxinxi": "Please verify the order details",
	"mall_flight_flightorder_shoujihaoma": "Mobile phone number",
  "mall_flight_flightorder_querenwuwuxiayibu": "Confirmed to be correct, Next step",
  "mall_hotel_hotel_ruzhushijian": "Check-in",
  "mall_hotel_hotel_gong": "Total",
  "mall_hotel_hotel_wan": "Nights",
  "mall_hotel_hotel_lidianshijian": "Check-out",
  "mall_hotel_hotel_guanjianziweizhipinpaijiudianming": "Key words/region/Brand/hotel name",
  "mall_hotel_hotel_qingshuruguanjianziweizhipinpaijiudianming": "Please fill in key words/region/Brand/hotel name",
  "mall_hotel_hotel_tianjialvke": "Add passenger",
  "mall_hotel_hotel_dianjixuanzelvke": "Click to select the passenger",
  "mall_hotel_hotel_sousuo": "Search",
  "mall_hotel_hotel_dfjqbycgjrzrqbycgwrx": "Please do not book over 5 rooms or 20 nights. If you have special needs please contact with customer service.",
  "mall_hotel_hotel_shanghai": "Shanghai",
  "mall_hotel_hotel_yueri": "MM-DD",
  "mall_hotel_hotel_qingxuanzelvke": "Please select the passenger",
  "mall_hotel_hotel_lvkeshuliangshangxianqinglianxikefu": "The amount of passengers reached limit. Please contact with customer service.",
  "mall_hotel_hotel_wenxintishi": "WARM PROMPT",
  "mall_hotel_hotel_zxydcgwfyknbzjylxkfh": "Book more than 20 nights. There is no adequent rooms provided. Please contact with customer service.",
  "mall_hotel_hotel_jixuyuding": "Continue to book",
  "mall_hotel_hotel_lianxikefu": "Contact with customer service",
  "mall_hotel_hotel_xiangqing": "Details",
  "mall_hotel_hoteldetails_fanhui": "Back",
  "mall_hotel_hoteldetails_pingfen": "Rating",
  "mall_hotel_hoteldetails_fen": "Ratings",
  "mall_hotel_hoteldetails_zanwupingfen": "No rating",
  "mall_hotel_hoteldetails_xingji": "Star rating",
  "mall_hotel_hoteldetails_tingchechang": "Parking lot",
  "mall_hotel_hoteldetails_jianshenfang": "Gym",
  "mall_hotel_hoteldetails_hanglijicun": "Luggage storage",
  "mall_hotel_hoteldetails_dizhi": "Address:{0}",
  "mall_hotel_hoteldetails_dianhua": "Telephone:{0}",
  "mall_hotel_hoteldetails_yueri": "MM-DD",
  "mall_hotel_hoteldetails_ruzhu": " Check in",
  "mall_hotel_hoteldetails_lidian": " Check out",
  "mall_hotel_hoteldetails_wan": "Night",
  "mall_hotel_hoteldetails_jianren": "Room",
  "mall_hotel_hoteldetails_qi": "From￥{0}",
  "mall_hotel_hoteldetails_zao": "Breakfast",
  // "mall_hotel_hoteldetails_kezhu": "Bookable",
  "mall_hotel_hoteldetails_kezhu": "Room for",
  // "mall_hotel_hoteldetails_ren": "Person",
  "mall_hotel_hoteldetails_ren": "guests",
  "mall_hotel_hoteldetails_bukequxiao": "Non-Refundable",
  "mall_hotel_hoteldetails_fuheguize": "Conforming rules",
  "mall_hotel_hoteldetails_weibeiguize": "Violating rules",
  "mall_hotel_hoteldetails_yuding": "Book",
  "mall_hotel_hoteldetails_gaijiudianzanwuheshifangjian": "The hotel cannot provide suitable rooms.",
  "mall_hotel_hoteldetails_xieyijiudian": "Contract hotels",
  "mall_hotel_hoteldetails_wu": "NONE",
  "mall_hotel_hoteldetails_dan": "One",
  "mall_hotel_hoteldetails_shuang": "Double",
  "mall_hotel_hoteldetails_duo": "Multiple",
  "mall_hotel_hoteldetails_weibei": "Violate",
  "mall_hotel_hoteldetails_gaifangjianyinweibeiguizebukeyuding": "The room cannot be booked because of violating policy",
  "mall_hotel_hoteldetails_wenxintishi": "WARM PROMPT",
  "mall_hotel_hoteldetails_bjdwxyjdknczfxqnzxbh": "This hotel is contract hotel. Please kindly note the potential risks and properly plan the trips, thank you.",
  "mall_hotel_hoteldetails_youchuang": "Has Window",
	"mall_hotel_hoteldetails_wuchuang": "No windos",
	"mall_hotel_hoteldetails_xianshiquxiao": "Refundable",
  "mall_hotel_hotellist_meiyougengduoliao": "No more",
  "mall_hotel_hotellist_qi": "From￥{0}",
  "mall_hotel_hotellist_fen": "Rating",
  "mall_hotel_hotellist_weibeiguize": "Violate rules",
  "mall_hotel_hotellist_fuheguize": "Conforming rules",
	"mall_hotel_hotellist_xianshiquanbu": "Show all",
  "mall_hotel_hotellist_jiazaizhong": "Processing",
  "mall_hotel_hotellist_xieyijiudian": "Contract hotels",
	"mall_hotel_hotellist_wukeyudingfangxing": "No available room types",
  // "mall_hotel_hotelorder_ruzhu": "Check in",
  "mall_hotel_hotelorder_ruzhu": "ARR:",
  "mall_hotel_hotelorder_wan": "Nigths",
  // "mall_hotel_hotelorder_lidian": "Check out",
  "mall_hotel_hotelorder_lidian": "DEP:",
  "mall_hotel_hotelorder_jian": "Room",
  "mall_hotel_hotelorder_dingdanquerenhoubukequxiao": "The order cannot be cancelled after confirmation",
  "mall_hotel_hotelorder_tuigaixiangqing": "Need to know",
  "mall_hotel_hotelorder_ruzhuxinxi": "Check-in information",
  "mall_hotel_hotelorder_dingdantianxie": "Fill order",
  "mall_hotel_hotelorder_yueri": "MM-DD",
  "mall_flight_hotelorder_qingheduidingdanxinxi": "Please verify the order details",
  "mall_flight_hotelorder_querenwuwuxiayibu": "Confirmed to be correct, Next step",
  "mall_modules_addpassengers_fanhui": "Back",
  "mall_modules_addpassengers_tianjiachengke": "Add passenger",
  "mall_modules_addpassengers_wancheng": "Complete",
  "mall_modules_addpassengers_qingshurulvkemingchengpipeihuotianjiaweilinke": "Please match the passenger name or add a temporary guest",
  "mall_modules_addpassengers_tianjia": "+ Add",
  "mall_modules_addpassengers_wei": " To",
  "mall_modules_addpassengers_linke": " Temporary guest",
  "mall_modules_addpassengers_shanchu": "Delete",
  "mall_modules_addpassengers_qingjianglinkemingchengshurudaosousuokuangneihouzhongshi": "Please enter the temporary guest name into the search box and try again.",
  "mall_modules_change_gaiqian": "Change",
  "mall_modules_change_gaiqianyuanyin": "Reason to change",
  "mall_modules_change_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun": "Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
  "mall_modules_change_xiayibuqingxuanzegaiqianriqi": "Next Step: please select the date you want to change",
  "mall_modules_change_tuigaiguize": "Policies",
  "mall_modules_change_woyaogaibianhangchengbuxiangfeiliao": "I want to change the schedule.",
  "mall_modules_change_jicuohangchengriqishijianxingming": "Forgot the itinerary, date, time or name",
  "mall_modules_change_hangbanyanwuhuoquxiao": "Flight delay or cancellation",
  "mall_modules_change_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin": "According to your company's trip rule, please select the reason of change",
  "mall_modules_change_qingxuanzexuyaogaiqiandelvcheng": "Please select the itinerary you want to change",
  "mall_modules_change_qingxuanzelvke": "Please select the passenger",
  "mall_modules_change_shanghai": "Shanghai",
  "mall_modules_change_beijing": "Beijing",
  "mall_modules_change_gaichecimeiyoupipeituigaiguize": "This train cannot match the policy.",
  "mall_modules_choosecontraryreason_weibeiyuanyin": "Reason of violations",
  "mall_modules_choosecontraryreason_qingshuruliyoumingcheng": "Please explain the reason",
  "mall_modules_choosecostcenter_chengbenzhongxin": "Cost center",
  "mall_modules_choosecostcenter_feiyongfudanbumen": "Expense-bearing department",
  "mall_modules_chooseprojectcode_qingshuruxiangmudaima": "Please write the project code",
  "mall_modules_chooseprojectcode_tianjia": "Add",
  "mall_modules_chooseprojectcode_weixiangmudaima": "Project code",
  "mall_modules_choosetripintent_chalvmude": "Travel purpose",
  "mall_modules_choosetripintent_qingshuruchalvmude": "Please fill in the purpose of travel",
  "mall_modules_editrole_fanhui": "Back",
  "mall_modules_editrole_tianjialinke": "Add temporary guest",
  "mall_modules_editrole_xingpinyin": "Last name",
  "mall_modules_editrole_mingpinyin": "First & middle name",
  "mall_modules_editrole_zhongwenxingming": "Chinese name",
  "mall_modules_editrole_qingshuruxingming": "Please enter your name ",
  "mall_modules_editrole_zhengjianleixing": "ID Type",
  "mall_modules_editrole_dianjixuanzezhengjianleixing": "Please select the ID Type",
  "mall_modules_editrole_xingbie": "Gender on ID",
  "mall_modules_editrole_dianjixuanzexingbie": "Please select the gender",
  "mall_modules_editrole_guoji": "Nationality",
  "mall_modules_editrole_dianjixuanzeguoji": "Please select the nationality",
  "mall_modules_editrole_zhengjianhaoma": "ID number",
  "mall_modules_editrole_qingshuruzhengjianhaoma": "Please enter the ID number",
  "mall_modules_editrole_chushengriqi": "Date of birth",
  "mall_modules_editrole_dianjixuanzechushengriqi": "Please select the date of birth",
  "mall_modules_editrole_shoujihaoma": "Telephone no.",
  "mall_modules_editrole_qingshurushoujihaoma": "Please enter the telephone no.",
  "mall_modules_editrole_youxiang": "Email",
  "mall_modules_editrole_qingtianxieyouxianghaoma": "Please fill in the email number",
  "mall_modules_editrole_sfbcwck": "Are regular visitors preserved",
  "mall_modules_editrole_baocun": "Save",
  "mall_modules_editrole_lichenggongsi": "Licheng Business Trip",
  "mall_modules_editrole_nan": "Male",
  "mall_modules_editrole_nv": "Female",
  "mall_modules_editrole_zhongguo": "China",
	"mall_modules_editrole_sclzcgkxzyjylkxxxggn": "Due to the restrictions imposed by the travel policy, the function for modifying passenger information has been disabled.",
  "mall_modules_frequentercardfill_fanhui": "Back",
  "mall_modules_frequentercardfill_tianxiechangkelvkeqia": "Fill in frequent flyer card No.",
  "mall_modules_frequentercardfill_zhangsan": "Chinese, pinyin or English",
  "mall_modules_frequentercardfill_qingxuanzehangkonggongsi": "Please select the airline",
  "mall_modules_frequentercardfill_qingtianxiechanglvkeqiahao": "Please fill in frequent flyer card No.",
  "mall_modules_frequentercardfill_wancheng": "Complete",
  "mall_modules_frequentercardfill_dongfanghangkong": "China Eastern Airlines",
  "mall_modules_frequentercardfill_zhongguohangkong": "Air China",
  "mall_modules_frequentercardfill_nanfanghangkong": "China Southern Airlines",
  "mall_modules_productdetails_fanhui": "Back",
  "mall_modules_producthome_chalvguizemingcheng": "Travel rules:",
  "mall_modules_producthome_guoji": "International ",
  "mall_modules_producthome_guonei": "Domestic ",
  "mall_modules_producthome_jipiaofuwu": "Air Ticket Service",
  "mall_modules_producthome_jiudianfuwu": "hotel services",
  "mall_modules_producthome_huochefuwu": "train services",
  "mall_modules_producthome_zuidijiagejizhun": "Lowest price standard:",
  "mall_modules_producthome_shishihangbanguankong": "Management of real time flight:",
  "mall_modules_producthome_tiqianyudingshijian": "Advanced booking time:",
  // "mall_modules_producthome_cangweijibiexianzhi": "Class limitation:",
  "mall_modules_producthome_cangweijibiexianzhi": "Available Seat:",
  // "mall_modules_producthome_zuoweijibiexianzhi": "Class limitation:",
  "mall_modules_producthome_zuoweijibiexianzhi": "Available Seat:",
  // "mall_modules_producthome_xieyijipiaoyouxian": "Contract tickets first:",
  "mall_modules_producthome_xieyijipiaoyouxian": "Agreement Flight Priority:",
  // "mall_modules_producthome_xieyijiudianyouxian": "Contract hotels first:",
  "mall_modules_producthome_xieyijiudianyouxian": "Agreement Hotel Priority:",
  "mall_modules_producthome_xiaofeijineshangxian": "Upper limitation of consumption:",
  "mall_modules_producthome_dangdizhusubiaozhun": "Local accommodation standard:",
  "mall_modules_producthome_shenpimingcheng": "Approval name:",
  "mall_modules_producthome_toudengcang": "First class",
  "mall_modules_producthome_shangwucang": "Business class",
  "mall_modules_producthome_jingjicang": "Economy class",
  "mall_modules_producthome_jingjicang5zhe": "Economy class (50% off)",
  "mall_modules_producthome_jingjicang6zhe": "Economy class (60% off)",
  "mall_modules_producthome_jingjicang7zhe": "Economy class (70% off)",
  "mall_modules_producthome_jingjicang8zhe": "Economy class (80% off)",
  "mall_modules_producthome_jingjicang9zhe": "Economy class (90% off)",
  "mall_modules_producthome_yinei": "Within",
  "mall_modules_producthome_bufenhangxian": "Some routes",
  "mall_modules_producthome_bufenjiudian": "Some hotels",
  "mall_modules_producthome_jichengshiyinei": "Tier {0} City: {1}-{2}",
  "mall_modules_producthome_yes": "YES",
	"mall_modules_producthome_no": "NO",
  "mall_modules_producthome_buxianzhi": "Unlimited",
  "mall_modules_producthome_xiangduizuidijia": "Lowest Relative Price",
  "mall_modules_producthome_quantianzuidijia": "Lowest Day  Price",
  "mall_modules_producthome_shiduanzuidijia": "Lowest Time Slot Price",
  "mall_modules_producthome_hangbanzuidijia": "Lowest Available Fare",
  "mall_modules_productlist_fanhui": "Back",
  "mall_modules_productlist_tuigaiguize": "Policies",
  "mall_modules_productlist_zhu": "ARR",
  "mall_modules_productlist_li": "DEP",
  "mall_modules_productlist_guanjianziweizhijiudianmingpinpai": "Key words/region/hotel name/Brand",
  "mall_modules_productlist_qianyitian": "Before",
  "mall_modules_productlist_houyitian": "After",
  "mall_modules_productlist_weizhijuli": "Location distance",
  "mall_modules_productlist_jiagexingji": "Price/star rating",
  "mall_modules_productlist_shaixuan": "Filter",
  "mall_modules_productlist_queren": "Confirm",
  "mall_modules_productlist_gengduoshaixuan": "More Filter",
  "mall_modules_productlist_chalvguizemingcheng": "Travel rules:",
  "mall_modules_productlist_zuidijiagejizhun": "Lowest price standard:",
  "mall_modules_productlist_shishihangbanguankong": "Management of real time flight:",
  "mall_modules_productlist_tiqianyudingshijian": "Advanced booking time:",
  // "mall_modules_productlist_cangweijibiexianzhi": "Class limitation:",
  "mall_modules_productlist_cangweijibiexianzhi": "Available Seat:",
  // "mall_modules_productlist_zuoweijibiexianzhi": "Class limitation:",
  "mall_modules_productlist_zuoweijibiexianzhi": "Available Seat:",
  // "mall_modules_productlist_xieyijipiaoyouxian": "Contract tickets first:",
  "mall_modules_productlist_xieyijipiaoyouxian": "Agreement Flight Priority:",
  // "mall_modules_productlist_xieyijiudianyouxian": "Contract hotels first:",
  "mall_modules_productlist_xieyijiudianyouxian": "Agreement Hotel Priority:",
  "mall_modules_productlist_xiaofeijineshangxian": "Upper limitation of consumption:",
  "mall_modules_productlist_dangdizhusubiaozhun": "Local accommodation standard:",
  "mall_modules_productlist_fudongfeilvshangxian": "Floating rate cap",
	"mall_modules_productlist_fudongjineshangxian": "Floating amount cap",
  "mall_modules_productlist_shenpimingcheng": "Approval name:",
  "mall_modules_productlist_toudengcang": "First class",
  "mall_modules_productlist_shangwucang": "Business class",
  "mall_modules_productlist_jingjicang": "Economy class",
  "mall_modules_productlist_jingjicangzhe": "Economy class (50% off)",
  "mall_modules_productlist_hangzhengqu": "Administrative area",
  "mall_modules_productlist_buxian": "Unlimited",
  "mall_modules_productlist_shangyequ": "Commercial areas",
  "mall_modules_productlist_jiage": "Price",
  "mall_modules_productlist_yixia": "Less than 150",
  "mall_modules_productlist_yishang": "More than 600",
  "mall_modules_productlist_xingji": "Star rating",
	"mall_modules_productlist_erxingjijiyixia":"2-Star & Below / Budget",
	"mall_modules_productlist_sanxingjishushi":"3-Star / Comfort",
	"mall_modules_productlist_sixingjigaodang":"4-Star / Upscale",
	"mall_modules_productlist_wuxingjihaohua":"5-Star / Luxury",
  "mall_modules_productlist_tese": "Features",
  "mall_modules_productlist_fuwu": "Service",
  "mall_modules_productlist_xieyijiudian": "Contract Hotel",
  "mall_modules_productlist_chexingxuanze": "Train type",
	"mall_modules_productlist_Huazhu": "Huazhu Hotel",
  "mall_modules_productlist_gaotie": "High-speed train(G/C)",
  "mall_modules_productlist_dongche": "High-speed train(D)",
  "mall_modules_productlist_putong": "Common(Z/T/K)",
  "mall_modules_productlist_qitadeng": "Other(L/Y etc.)",
  "mall_modules_productlist_qita": "Other",
  "mall_modules_productlist_facheshijian": "Departure Time",
  "mall_modules_productlist_chalvzhengce": "Travel rules",
  "mall_modules_productlist_fuheguize": "Conforming rules",
  "mall_modules_productlist_weibeiguize": "Violate rules",
  "mall_modules_productlist_chufachezhan": "Departure Station",
  "mall_modules_productlist_daodachezhan": "Arrival Station",
  "mall_modules_productlist_zhinengpaixu": "Intelligent sorting",
  "mall_modules_productlist_morenpaixu": "Default sort",
  "mall_modules_productlist_dijiayouxian": "Lowest",
  "mall_modules_productlist_gaojiayouxian": "Highest",
  "mall_modules_productlist_xingjiyouxian": "Star rating first",
  "mall_modules_productlist_putongyouxian": "Common first",
  "mall_modules_productlist_shijianpaixu": "Time sorting",
  "mall_modules_productlist_congzaodaowan": "Earliest to latest",
  "mall_modules_productlist_congwandaozao": "Latest to earliest",
  "mall_modules_productlist_jiagepaixu": "Price ranking",
  "mall_modules_productlist_congdidaogao": "Low to high",
  "mall_modules_productlist_conggaodaodi": "High to low",
  "mall_modules_productlist_qifeishijian": "Departure Time",
  "mall_modules_productlist_qifeijichang": "Departure Airport",
  "mall_modules_productlist_daodajichang": "Arrival Airport",
  "mall_modules_productlist_cangwei": "Class",
	"mall_modules_productlist_gongxianghangban":"sharing flight",
	"mall_modules_productlist_yincanggongxianghangban": "Hidden shared flight",
  "mall_modules_productlist_hangkonggongsi": "Airline",
  "mall_modules_productlist_yinei": "Within",
  "mall_modules_productlist_bufenhangxian": "Some routes",
  "mall_modules_productlist_bufenjiudian": "Some hotels",
  "mall_modules_productlist_jichengshiyinei": "Within  -class city",
  "mall_modules_productlist_zhongzhuanzhifei": "Nostop/Transit",
	"mall_modules_productlist_jinkanzhongzhuan": "Looking Transit",
	"mall_modules_productlist_jinkanzhifei": "Looking Nostop",
  "mall_modules_addkeywords_guanjianziweizhijiudianmingpinpai": "Key words/region/hotel name/Brand",
  "mall_modules_addkeywords_qsrhxggjzwzppjdmckssjg": "Please enter or modify keywords / location / brand / hotel name to view the search results",
  "mall_modules_refund_tuidingyuanyin": "Reason for Cancellation",
  "mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun": "Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
  "mall_modules_refund_zongji": "Total",
	"mall_modules_refund_yujituipiaofei": "Refund Fee：",
  "mall_modules_refund_mingxi": "Details",
  "mall_modules_refund_tijiaoshenhe": "Submit trip approval",
  "mall_modules_refund_hangchengbiangeng": "Travel change",
  "mall_modules_refund_hangchengquxiao": "Travel cancellation",
  "mall_modules_refund_woyaogaibianhangchengbuxiangfeiliao": "I want to change the schedule",
  "mall_modules_refund_jicuohangchengriqishijianxingming": "Forgot the itinerary, date, time or name",
  "mall_modules_refund_hangbanyanwuhuoquxiao": "Flight delay or cancellation",
  "mall_modules_refund_genjuguisidechalvbiaozhunqingxuanzetuidingyuanyin": "According to your company's trip rule, please select the reason of refund",
  "mall_modules_refund_shenqingtuipiao": "Apply a refund",
  "mall_modules_refund_shenqingtuifang": "Apply a refund",
  "mall_modules_refund_qingxuanzexuyaotuidingdelvcheng": "Please select the itinerary you want to refund",
  "mall_modules_refund_qingxuanzelvke": "Please select the passenger",
  "mall_modules_refund_qingxuanzetuidingyuanyin": "Please select the reason of refund",
  "mall_modules_refund_tuipiaoshenqingtijiaochenggong": "The refund application is submitted successfully",
  "mall_modules_remarks_xuqiubeizhu": "Requirements note",
  "mall_modules_remarks_baocun": "Save",
  "mall_modules_remarks_ndtsxqwmhjlxtrwfmzwm": "We will try our best to coordinate with your special needs. If it cannot be satisfied, we will not notify you, please understand",
  "mall_order_shifa": "Departure ",
  "mall_order_jingting": "Stop",
  "mall_order_yueri": "MM-DD ddd",
  "mall_order_tuigaixuzhi": "Change prompt",
  // "mall_order_fangjianshu": "Number of Rooms",
  "mall_order_fangjianshu": "Rooms",
  "mall_order_jian": "Room",
  "mall_order_rfjcgwjsklxkfhcfyd": "If there are more than 5 rooms, please contact customer service or split the booking!",
  // "mall_order_meijianzuiduokezhu": "Each room can live at most",
  "mall_order_meijianzuiduokezhu": "Room for",
  // "mall_order_ren": "Person",
  "mall_order_ren": "guests",
  "mall_order_zuoxixuanze": "Seat Selection",
  "mall_order_chuang": "Window",
  "mall_order_guodao": "Aisle",
  "mall_order_wbzndslcxqwbbztxxycysczjyz": "In order to make sure that the entry is consistent with the certificate you have for your trip",
  "mall_order_fasongduanxin": "Send message",
  "mall_order_baoxianxinxi": "Insurance information",
  "mall_order_yqqjjqfhslrsbxdzfwyf": "Enhancing protection During COVID-19, customizing insurance services for business travelers. one protection, peace of mind for the whole family",
  "mall_order_shanglvxinxi": "Business Travel Information",

	"mall_order_shenpipingzheng": "Certificate Of Approval",
	"mall_order_youshenpipingzheng": "Within Certificate Of Approval",
	"mall_order_wushenpipingzheng": "Without Certificate Of Approval",
	"mall_order_shenpizhuangtai": "Status Of Approval",
	"mall_order_chuchaishenqingiworkyishenpi": "Travel application iworker Approved",
	"mall_order_shangweishenpi": "Not Approved",
	"mall_order_yijishenpi": "Primary Approval",

  "mall_order_shenpidanhao": "Approval number",
  "mall_order_liuchenglingdaochuchabaogaodanhao": "IMIS Process leader business trip report number",
  "mall_order_chengbenzhongxin": "Cost center",
  "mall_order_feiyongfudanbumen": "Expense-bearing department",
  "mall_order_qingxuanzechengbenzhongxin": "Please select cost center",
  "mall_order_qingxuanzefeiyongfudanbumen": "Please select expense-bearing department",
  "mall_order_chalvmude": "Travel purpose",
  "mall_order_qingxuanzechalvmude": "Please select the travel purpose",
  "mall_order_mudexiangqing": "Travel purpose",
  "mall_order_chalvmudebumingquexubuchongxiangxichalvmude": "The travel purpose is not clear. Please add the details.",
  "mall_order_xiangmudaima": "Project code",
  "mall_order_qingxuanzexiangmudaima": "Please select project code",
  "mall_order_weibeiyuanyin": "Reason of violations",
	"mall_order_yusuanbianma": "BudgetCode",
	"mall_order_fujianxinxi": "Attachment Info",
  "mall_order_yusuanmiaoshu": "BudgetIntro",
  "mall_order_xingchengweibeile": "The schedule violates",
  "mall_order_xiaofeijineshangxian": "Maximum Spending Amount",
	"mall_order_dangdizhusubiaozhun": "Local Accommodation Standard",
	'mall_order_dezhengce': "the policy of",
  "mall_order_qingxuanzeweibeiyuanyin": "Please select the reason of violations",
  "mall_order_xiangxiyuanyin": "Reason",
  "mall_order_lianxirenxinxi": "Contact details",
  "mall_order_xingming": "Name",
  "mall_order_qingshuruyonghuming": "Please enter user name",
  "mall_order_shouji": "Tel",
  "mall_order_qingshurushoujihao": "Please enter the telephone no.",
  "mall_order_youxiang": "E-mail",
  "mall_order_qingshuruyouxiang": "Please enter the email address",
  "mall_order_xuqiubeizhu": "Special Requests",
  "mall_order_koukuanshuoming": "Deduction instructions",
  "mall_order_hgjndfkfsjhysqhkcffr": "According to the payment method we will pre-authorize your card or deduct room fee. If the order is not confirmed, we will release the pre-authorization or give you a full refund to your account. The order can't be changed or cancelled. You will be billed for the first night's room charge if you don't check in. If you check out in advance you will be billed for the day's room charge.",
  "mall_order_tebietishi": "Special Requests",
  "mall_order_gjddrzsjwtfbzjssjwrt": "The earliest check-in time is 14:00. The check-out time is 12:00. If you arrive before this time or departure after this time, you may need subject to a fee.",
  "mall_order_mingxi": "Details",
  "mall_order_tijiaozhifu": "Book",
  "mall_order_feiyongmingxi": "Price Details",
  "mall_order_baoxianfei": "Insurance premiums",
  "mall_order_fuwufei": "Service charge",
  "mall_order_zonge": "Total",
  "mall_order_dingdanzhengzaishengcheng": "Order is being generated",
  "mall_order_nulizhanzuozhong": "Processing",
  "mall_order_tuipiaoshuoming": "Refund instructions",
  "mall_order_dgcgwqpqfcqsjdyfzkjr": "Purchase successfully. If the ticket is not collected or the time before departure is more than 35 minutes, you can enter “my booking”to apply for refund according to the prompt; refund within 15 days before departure, the Railway Bureau will charge a refund fee for each ticket on a ladder basis.",
  "mall_order_dgcgyqphfcqsjxyfzxnz": "Purchase successfully. If tickets have been collected or the time before departure is less than 35 minutes, you should bring the passenger’s original valid certificate and the train ticket to the railway station refund window before departure.",
  "mall_order_gaiqianshuoming": "Change instructions",
  "mall_order_wqzzpqlfcsjdyfzkgqdy": "If the ticket is not collected or the time before departure is more than 35 minutes, the tickets can be changed to the train equal to or less than the original fare.",
  "mall_order_kcqxsyskgqysqndcckcq": "More than 48 hours before the departure time, you can change the train of pre-sale period. Within 48 hours before the departure time, you can change your tickets to any train before 24:00 on the day. The tickets cannot be changed to the train on the day after the date of the original one.",
  "mall_order_xcppjdyycpdthcédcébf": "If the new ticket price is lower than the original ticket, the difference shall be returned. And the refund fee for the difference shall be collected and the current refund fee standards shall be implemented.",
  "mall_order_querendingdan": "Confirm Order",
  "mall_order_xuanzechuhangren": "Select the passenger",
  "mall_order_lichenggongsi": "Licheng Business Trip",
  "mall_order_yi": "First",
  "mall_order_er": "Second ",
  "mall_order_san": "Third",
  "mall_order_yueri1": "MM-DD",
  "mall_order_qingtianxiexiangmudaima": "Please fill in the project code",
  "mall_order_qingtianxieshenpidanhao": "Please fill in the approval order no",
  "mall_order_qingtianxiechalvmude": "Please fill in the purpose of travel",
  "mall_order_qingtianxiexiangqingmude": "Please fill in the detail of purpose",
  "mall_order_qingtianxieweibeixiangqingyuanyin": "Please fill in the reason of violations",
  "mall_order_ghbjpwzhxscpnxxzyzbx": "This flight ticket is a combination sale product, you need to select an insurance product. Or please choose another flight ticket",
  "mall_order_gcczxwzhxscpnxxzyzbx": "This train is a combination sales product, you need to select an insurance product. Or please choose another train",
  "mall_order_qingtianxielvkezhengjianhaoma": "Please enter the ID number",
  "mall_order_wenxintishi": "WARM PROMPT",
  "mall_order_shifoujixuyuding": "Continue booking or not",
  "mall_order_ddcjcghynsszddxxzgzd": "The order is created successfully, you are welcome to follow the order progress in the order details at any time",
  "mall_order_hejiazhong": "Price checking",
  "mall_order_fangjianshubukedayuruzhurenshu": "The number of rooms cannot be greater than the number of occupants",
  "mall_train_train_chufadi": "Departure",
  "mall_train_train_mudedi": "Arrival",
  "mall_train_train_chufashijian": "Departure time",
  "mall_train_train_zuoxi": "Seat",
  "mall_train_train_yidengzuo": "First class",
  "mall_train_train_tianjialvke": "Add passenger",
  "mall_train_train_dianjixuanzelvke": "Click to select the passenger",
  "mall_train_train_sousuo": "Search",
  "mall_train_train_dangqianshiduanbutigongchecichaxunfuwu": "We don't provide train service in the current time",
  "mall_train_train_tsgpsjwzwgpgqhtpxbwy": "NOTICE: Booking time is from 5:30 am to 00:30 pm. You can book,change and refund tickets more than 30 minutes prior to departure. The tickets within 24 hours should be paid in 10 minutes. The tickets beyond 24 hours should be paid in 25 minutes.",
  "mall_train_train_shanghai": "Shanghai",
  "mall_train_train_beijing": "Beijing",
  "mall_train_train_yueri": "MM-DD",
  "mall_train_train_qingxuanzelvke": "Please select the passenger",
  "mall_train_trainchangeinfos_gaiqian": "Change",
  "mall_train_trainchangeinfos_yuanchecixinxi": "Original train info",
  "mall_train_trainchangeinfos_di": "No.",
  "mall_train_trainchangeinfos_cheng": "Trip",
  "mall_train_trainchangeinfos_yueri": "MM-DD",
  "mall_train_trainchangeinfos_tuigaiguize": "Policies",
  "mall_train_trainchangeinfos_xinchecixinxi": "New train info",
  "mall_train_trainchangeinfos_chuhangrenxinxi": "Passenger info",
  "mall_train_trainchangeinfos_shouji": "Telephone no.",
  "mall_train_trainchangeinfos_shenfenzheng": "ID number",
  "mall_train_trainchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyishijishenheweizhun": "Refund and change rules and fee standards should be determined by the actual review",
  "mall_train_trainchangeinfos_zongji": "Total",
  "mall_train_trainchangeinfos_mingxi": "Details",
  "mall_train_trainchangeinfos_tijiaoshenhe": "Submit trip approval",
  "mall_train_trainchangeinfos_woyaogaibianhangchengbuxiangfeiliao": "I want to change the schedule",
  "mall_train_trainchangeinfos_jicuohangchengriqishijianxingming": "Forgot the itinerary, date, time or name",
  "mall_train_trainchangeinfos_hangbanyanwuhuoquxiao": "Flight delay or cancellation",
  "mall_train_trainchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin": "According to your company's trip rule, please select the reason of change",
  "mall_train_trainchangeinfos_gaiqianchenggongqingninguanzhudingdanzhuangtai": "The change is successful. please pay attention to the status of the order!",
  "mall_train_trainchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie": "The current order cannot be changed, please contact customer service, thank you!",
  "mall_train_traindetails_checixiangqing": "Train details",
  "mall_train_traindetails_tuigaiguize": "Policies",
  "mall_train_traindetails_shifa": "Departure ",
  "mall_train_traindetails_weibeiguize": "Violating rules",
  "mall_train_traindetails_fuheguize": "Conforming rules",
  "mall_train_traindetails_youpiao": "enough",
  "mall_train_traindetails_wupiao": "Sold out",
  "mall_train_traindetails_jinsheng": "Only ",
  "mall_train_traindetails_zhang": "Ticket",
  "mall_train_traindetails_ding": "Book",
  "mall_train_traindetails_tuipiaoshuoming": "Refund instructions",
  "mall_train_traindetails_dgcgwqpqfcqsjdyfzkjr": "Book successfully. If the ticket is not collected or the time before departure is more than 35 minutes, you can enter “my booking”to apply for refund according to the prompt; refund within 15 days before departure, the Railway Bureau will charge a refund fee for each ticket on a ladder basis.",
  "mall_train_traindetails_dgcgyqphfcqsjxyfzxnz": "Book successfully. If tickets have been collected or the time before departure is less than 35 minutes, you should bring the passenger’s original valid certificate and the train ticket to the railway station refund window before departure.",
  "mall_train_traindetails_gaiqianshuoming": "Change instructions",
  "mall_train_traindetails_wqzzpqlfcsjdyfzkgqdy": "If the ticket is not collected or the time before departure is more than 35 minutes, the tickets can be changed to the train equal to or less than the original fare.",
  "mall_train_traindetails_kcqxsyskgqysqndcckcq": "More than 48 hours before the departure time, you can change the train of pre-sale period. Within 48 hours before the departure time, you can change your tickets to any train before 24:00 on the day. The tickets cannot be changed to the train on the day after the date of the original one.",
  "mall_train_traindetails_xcppjdyycpdthcédcébf": "If the new ticket price is lower than the original ticket, the difference shall be returned. And the refund fee for the difference shall be collected and the current refund fee standards shall be implemented.",
  "mall_train_traindetails_weibei": "Violate",
  "mall_train_trainlist_weibeiguize": "Violate rules",
  "mall_train_trainlist_fuheguize": "Conforming rules",
  "mall_train_trainlist_shouqi": "Show less",
  "mall_train_trainlist_zhankai": "Show More",
  "mall_train_trainlist_you": "Exist",
  "mall_train_trainlist_zhang": "Ticket",
  "mall_train_trainlist_wu": "Not",
  "mall_train_trainlist_zhanxu": "Station no.",
  "mall_train_trainlist_zhanming": "Station name",
  "mall_train_trainlist_daoshi": "Arrival time",
  "mall_train_trainlist_fashi": "Depart time",
  "mall_train_trainlist_tingliu": "Stopover",
  "mall_train_trainlist_jiazaizhong": "Processing",
  "mall_train_trainlist_xiuxizhongmingtianzailai": "Rest",
  "mall_train_trainlist_dqcczxwypqnlxqtcchlā": "There are no more seats for the current train! Please choose another train and arrange your trip reasonably, thank you!",
  "mall_train_trainlist_qita": "Other",
  "mall_train_trainorder_zhifei": "Non-stop",
  "mall_train_trainorder_yueri": "MM-DD",
  "mall_train_trainorder_piaojia": "Price",
  "mall_train_trainorder_yuan": "",
  "mall_train_trainorder_jijianranyou": "Airport construction fee",
  "mall_train_trainorder_yuanrenbaoxianyuanren": "Insurance 20CNY/per",
  "mall_train_trainorder_checixiangqing": "Details",
  "modules_selectcity_qingshuruchengshimingcheng": "Please enter the city name ",
  "modules_selectcity_guoji": "International",
	"modules_selectcity_guonei": "Domestic",
  "modules_selectcity_diqu": "Area",
  "modules_selectcity_chezhan": "Station",
  "modules_selectcity_remen": "Hot ",
  "modules_webmap_dingwei": "Location",
  "modules_webmap_wodebeizhu": "My notes",
  "modules_webmap_wodebiaoji": "My mark",
  "order_flight_flightdetail_di": "",
  "order_flight_flightdetail_yi": "First",
	"order_flight_flightdetail_er": "Another",
  "order_flight_flightdetail_cheng": "Trip",
  "order_flight_flightdetail_yueri": "MM-DD",
  "order_flight_flightdetail_tuigaiguize": "Policies",
  "order_flight_flightorderinfo_dancheng": "One-way trip",
  "order_flight_flightorderinfo_weibeiguize": "Violating rules",
  "order_flight_flightorderinfo_gongxiang": "Shared",
  "order_flight_flightorderinfo_nianyueri": "YYYY-MM-DD ddd",
  "order_flight_flightorderinfo_tuigaiguize": "Policies",
  "order_flight_flightorderinfo_yiquxiao": "Cancelled",
  "order_flight_flightorderinfo_weibeizhengceyuanyin": "Reasons of Violating policy:{0}",
	"order_flight_flightorderinfo_weibeixiangqing": "Violating Details：",
  "order_flight_flightorderinfo_quchuli": "To deal with",
	"order_flight_flightorderinfo_details": "details",
  "order_flight_flightorderinfo_fuhezhengcedingdanshenpi": "Conforming policy order approval",
  "order_flight_flightorderinfo_mingxi": "Details",
  "order_flight_flightorderinfo_gaiqian": "Change",
  "order_flight_flightorderinfo_tuipiao": "Refund",
  "order_flight_flightorderinfo_quxiaotuipiao": "Cancel refund",
  "order_flight_flightorderinfo_quxiaogaiqian": "Cancel change",
  "order_flight_flightorderinfo_quxiaodingdan": "Cancel order",
  "order_flight_flightorderinfo_shenpi": "Approve",
  "order_flight_flightorderinfo_shenqingren": "Applicant:{0}",
  "order_flight_flightorderinfo_gaiqianren": "Passenger:{0}",
  "order_flight_flightorderinfo_gaiqianyuanyin": "Reason to change:{0}",
  "order_flight_flightorderinfo_xiangqingyuanyin": "Reason:{0}",
  "order_flight_flightorderinfo_jiazaizhong": "Processing",
  "order_flight_flightorderinfo_yunxutuipiao": "Cancellations permitted",
  "order_flight_flightorderinfo_jujuetuipiao": "Non-refundable",
  "order_flight_flightorderinfo_yunxugaiqian": "Changes permitted",
  "order_flight_flightorderinfo_jujuegaiqian": "Non-changeable",
  "order_flight_flightorderinfo_shenpitongguo": "Approved",
  "order_flight_flightorderinfo_shenpijujue": "Rejected",
  "order_flight_flightorderinfo_xiaoshizhi": "hours to",
	"order_flight_flightorderinfo_tianqian": "days before",
	"order_flight_flightorderinfo_tianzhi": "days to",
	"order_flight_flightorderinfo_gaiqianshouqu": "Change fee charged",
	"order_flight_flightorderinfo_tuipiaoshouqu": "Refund fee charged",
	"order_flight_flightorderinfo_deshouxufei": "service fee",
	"order_flight_flightorderinfo_xiaoshiqian": "hours before",
	"order_flight_flightorderinfo_xiaoshizhiqian": "hours before",
	"order_flight_flightorderinfo_xiaoshizhihou": "hours after",
	"order_flight_flightorderinfo_tianzhiqian": "days before",
	"order_flight_flightorderinfo_qifeiqian": "take off before",
	"order_flight_flightorderinfo_qifeihou": "take off after",
	"order_flight_flightorderinfo_xiaoshi": "hours",
	"order_flight_flightorderinfo_tian": "days",
  "order_hotel_hoteldetail_wan": "Night",
  "order_hotel_hoteldetail_tuigaixiangqing": "Policies details",
  "order_hotel_hoteldetail_ri": "Day",
  "order_hotel_hoteldetail_yi": "One ",
  "order_hotel_hoteldetail_er": "Two",
  "order_hotel_hoteldetail_san": "Three",
  "order_hotel_hoteldetail_si": "Four",
  "order_hotel_hoteldetail_wu": "Five",
  "order_hotel_hoteldetail_liu": "Six",
  "order_hotel_hoteldetail_zhou": "Week",
  "order_hotel_hoteldetail_wuzao": "Breakfast is not included",
  "order_hotel_hotelorderinfo_yueri": "MM-DD",
	"order_hotel_hotelorderinfo_jian": "Rooms",
  "order_hotel_hotelorderinfo_wan": "Night",
  "order_hotel_hotelorderinfo_weibeiguize": "Violating rules",
  "order_hotel_hotelorderinfo_jiudianxiangqing": "Hotel Description",
  "order_hotel_hotelorderinfo_tuigaiguize": "Policies",
  "order_hotel_hotelorderinfo_yiquxiao": "Cancelled",
  "order_hotel_hotelorderinfo_wozhidaoliao": "I see",
  "order_hotel_hotelorderinfo_weibeizhengceyuanyin": "Reasons of Violating policy",
  "order_hotel_hotelorderinfo_quchuli": "To deal with",
  "order_hotel_hotelorderinfo_fuhezhengcedingdanshenpi": "Conforming policy order approval",
  "order_hotel_hotelorderinfo_mingxi": "Details",
  "order_hotel_hotelorderinfo_shenqingtuifang": "Apply to cancel reservation",
  "order_hotel_hotelorderinfo_quxiaotuifang": "Cancel reservation cancellation",
  "order_hotel_hotelorderinfo_quxiaodingdan": "Cancel order",
  "order_hotel_hotelorderinfo_shenpi": "Approval",
  "order_hotel_hotelorderinfo_shenqingren": "Applicant:{0}",
  "order_hotel_hotelorderinfo_gaiqianren": "Passenger:{0}",
  "order_hotel_hotelorderinfo_gaiqianyuanyin": "Reason to change:{0}",
  "order_hotel_hotelorderinfo_wuzao": "Breakfast is not included",
  "order_orderInfo_yunxutuipiao": "Allow refund",
  "order_orderInfo_jujuetuipiao": "Refusal to refund",
  "order_orderInfo_yunxugaiqian": "Allow to change",
  "order_orderInfo_jujuegaiqian": "Refuse to change",
  "order_orderInfo_shenpitongguo": "Approved",
  "order_orderInfo_shenpijujue": "Approval denied",
  "order_orderInfo_tuipiaoren": "Passenger",
  "order_orderInfo_tuipiaoyuanyin": "Reason for refund",
  "order_orderInfo_gaiqianren": "Passenger",
  "order_orderInfo_gaiqianyuanyin": "Reason for change",
  "order_orderInfo_chuxingren": "Passenger",
  "order_orderInfo_chuxingmudi": "Travel purpose",
  "order_orderdetails_dingdanxiangqing": "Order detail",
  "order_orderdetails_dingdanhao": "Order no.{0}",
  "order_orderdetails_ruzhurenxinxi": "Guest info",
  "order_orderdetails_chuhangrenxinxi": "Passenger info",
  "order_orderdetails_shouji": "Telephone",
  "order_orderdetails_shenfenzheng": "IDCard",
  "order_orderdetails_shanglvxinxi": "Business travel information",
  "order_orderdetails_chengbenzhongxin": "Cost center",
  "order_orderdetails_feiyongfudanbumen": "expense-bearing department",
  "order_orderdetails_chalvmudi": "Travel purpose",
  "order_orderdetails_chuchaishiyou": "Business Trip Purpose",
  "order_orderdetails_xiangmudaima": "Project code",
  "order_orderdetails_lianxiren": "Contact details",
  "order_orderdetails_xingming": "Name",
  "order_orderdetails_youxiang": "Email address",
  "order_orderdetails_xuqiubeizhu": "Requirements notes",
  "order_orderdetails_fujianxinxi": "Attachment Info",
  "order_orderdetails_fujianmingcheng": "Attachment Name",
  "order_orderdetails_caozuo":"Operate",
  "order_orderdetails_w": "Nix",
  "order_orderdetails_koukuanshuoming": "Deduction instructions",
  "order_orderdetails_hgjndfkfsjhysqhkcffr": "According to the payment method we will pre-authorize your card or deduct room fee. If the order is not confirmed, we will release the pre-authorization or give you a full refund to your account. The order can't be changed or cancelled. You will be billed for the first night's room charge if you don't check in. If you check out in advance you will be billed for the day's room charge.",
  "order_orderdetails_tebietishi": "Special Requests",
  "order_orderdetails_gjddrzsjwtfbzjssjwrt": "The earliest check-in time is 14:00. The check-out time is 12:00. If you arrive before this time or departure after this time, you may need subject to a fee.",
  "order_orderdetails_zongji": "Total",
  "order_orderdetails_mingxi": "Details",
  "order_orderdetails_feiyongmingxi": "Price Details",
  "order_orderdetails_baoxianfei": "Insurance premiums",
  "order_orderdetails_fuwufei": "Service charge",
  "order_orderdetails_zonge": "Total",
  "order_orderdetails_tuigaiguize": "Policies",
  "order_orderdetails_ri": "Sunday",
  "order_orderdetails_yi": "Monday",
  "order_orderdetails_er": "Tuesday",
  "order_orderdetails_san": "Wednesday",
  "order_orderdetails_si": "Thursday",
  "order_orderdetails_liu": "Saturday",
  "order_orderdetails_zhou": "Week",
  'order_orderdetails_yiwancheng':"Finished",
	'order_orderdetails_yiquxiao':"Canceled",
	'order_orderdetails_yituihui':"Rejected",
	'order_orderdetails_daishenpi':"WaitApprove",
	'order_orderdetails_daichuli':"WaitDispose",
	'order_orderdetails_daiqueren':"WaitConfirm",
  "order_orderdetails_tuifangchulizhong":"Unsubscribe processing",
  "order_orderdetails_tuituanchulizhong":"Unsubscribe processing",
  "order_orderdetails_tuipiaochulizhong":"Unsubscribe processing",
  "order_orderdetails_youtuifang":"There is a refund",
  "order_orderdetails_youtuituan":"There is a refund",
  "order_orderdetails_youtuipiao":"There is a refund",
  "order_orderdetails_gaiqianchulizhong":"Changing processing",
  "order_orderdetails_yougaiqian":"There is a chang",
  "order_orderdetails_quanbugaiqian":"All change",
  "order_orderdetails_quanbutuifang":"Full refund",
  "order_orderdetails_quanbutuipiao":"Full refund",
  "order_orderdetails_quanbugaiqianzhong":"Resigning all",
  "order_orderdetails_quanbutuifangzhong":"Unsubscribe all",
  "order_orderdetails_quanbutuipiaozhong":"Unsubscribe all",
  "order_orderlist_wodedingdan": "My booking",
  "order_orderlist_meiyougengduoliao": "No more",
  "order_orderlist_yudingshijian": "Order time",
  "order_orderlist_weibeiguize": "Violating rules",
  "order_orderlist_fuheguize": "Conform to rules",
  "order_orderlist_chufa": "Departure",
  "order_orderlist_zhi": "From",
  "order_orderlist_wei": "To",
  "order_orderlist_yuding": "Book",
  "order_orderlist_yueri": "MM-DD",
  "order_orderlist_jipiao": "Ticket",
  "order_orderlist_jiudian": "Hotel",
  "order_orderlist_huoche": "Train",
  "order_orderlist_zuche": "TakeTaxi",
  "order_train_traindetail_di": "",
  "order_train_traindetail_cheng": "Trip",
  "order_train_traindetail_yueri": "MM-DD",
  "order_train_traindetail_tuigaiguize": "Policies",
  "order_train_trainorderinfo_dancheng": "One-way trip",
  "order_train_trainorderinfo_weibeiguize": "Violating rules",
  "order_train_trainorderinfo_gongxiang": "Shared",
  "order_train_trainorderinfo_jianpiaokou": "Gate",
  "order_train_trainorderinfo_zhida": "Non-stop",
  "order_train_trainorderinfo_zongyongshi": "Total duration{0}",
  "order_train_trainorderinfo_nianyueri": "YYYY-MM-DD",
  "order_train_trainorderinfo_tuigaiguize": "Policies",
  "order_train_trainorderinfo_yiquxiao": "Cancelled",
  "order_train_trainorderinfo_tuipiaoshuoming": "Refund instructions",
  "order_train_trainorderinfo_dgcgwqpqfcqsjdyfzkjr": "1.Book successfully. If the ticket is not collected or the time before departure is more than 35 minutes, you can enter “my booking”to apply for refund according to the prompt; refund within 15 days before departure, the Railway Bureau will charge a refund fee for each ticket on a ladder basis.",
  "order_train_trainorderinfo_dgcgyqphfcqsjxyfzxnz": "2.Book successfully. If tickets have been collected or the time before departure is less than 35 minutes, you should bring the passenger’s original valid certificate and the train ticket to the railway station refund window before departure.",
  "order_train_trainorderinfo_gaiqianshuoming": "Change instructions",
  "order_train_trainorderinfo_wqzzpqlfcsjdyfzkgqdy": "1.If the ticket is not collected or the time before departure is more than 35 minutes, the tickets can be changed to the train equal to or less than the original fare.",
  "order_train_trainorderinfo_kcqxsyskgqysqndcckcq": "2.More than 48 hours before the departure time, you can change the train of pre-sale period. Within 48 hours before the departure time, you can change your tickets to any train before 24:00 on the day. The tickets cannot be changed to the train on the day after the date of the original one.",
  "order_train_trainorderinfo_xcppjdyycpdthcédcébf": "3.If the new ticket price is lower than the original ticket, the difference shall be returned. And the refund fee for the difference shall be collected and the current refund fee standards shall be implemented.",
  "order_train_trainorderinfo_wozhidaoliao": "I see",
  "order_train_trainorderinfo_mingxi": "Details",
  "order_train_trainorderinfo_weibeizhengceyuanyin": "Reasons of Violating policy:{0}",
  "order_train_trainorderinfo_quchuli": "To deal with",
  "order_train_trainorderinfo_fuhezhengcedingdanshenpi": "Conforming policy order approval",
  "order_train_trainorderinfo_gaiqian": "Change",
  "order_train_trainorderinfo_tuipiao": "Refund",
  "order_train_trainorderinfo_quxiaotuipiao": "Cancel refund",
  "order_train_trainorderinfo_quxiaogaiqian": "Cancel change",
  "order_train_trainorderinfo_quxiaodingdan": "Cancel order",
  "order_train_trainorderinfo_shenpi": "Approve",
  "order_train_trainorderinfo_shenqingren": "Applicant:{0}",
  "order_train_trainorderinfo_gaiqianren": "Passenger:{0}",
  "order_train_trainorderinfo_gaiqianyuanyin": "Reason to change:{0}",
  "order_train_trainorderinfo_xiangqingyuanyin": "Reason:{0}",
  "system_newaddress_shezhimorendizhi": "Processing",
  "system_newaddress_shanchu": "Delete",
  "system_about_about_lichengshanglv": "Licheng Business Trip",
  "system_approvalset_provisionalauthorization_linshishenpishouquan": "Temporary approval authorization",
  "system_approvalset_provisionalauthorization_qingxuanze": "Please select",
  "system_approvalset_provisionalauthorization_shouquanyuangong": "Authorized employees",
  "system_approvalset_provisionalauthorization_kaishiriqi": "Start date ",
  "system_approvalset_provisionalauthorization_xuanzeshijian": "Select time",
  "system_approvalset_provisionalauthorization_jiezhishijian": "End date ",
  "system_approvalset_provisionalauthorization_shouquanshichang": "Authorized time",
  "system_approvalset_provisionalauthorization_xiaoshi": "Hour",
  "system_approvalset_provisionalauthorization_tian": "Day",
  "system_approvalset_provisionalauthorization_shi": "Hour",
  "system_approvalset_list_baocun": "Save",
  "system_approvalset_list_shouquanliebiao": "Authorization list",
  "system_approvalset_list_yijianqingchu": "Clear",
  "system_approvalset_list_yiguoqi": "Expired",
  "system_approvalset_list_shouquanzhong": "Authorized",
  "system_approvalset_list_quxiaoxiugai": "Cancel change",
  "system_approvalset_list_qingxuanzeshouquanyuangong": "Please select authorized employees",
  "system_autoupdate_autoupdate_faxianxinbanben": "New version found",
  "system_autoupdate_autoupdate_xinzeng": "Add",
  "system_autoupdate_autoupdate_lijigengxin": "Update now",
  "system_configinfo_configinfo_baocun": "Save",
  "system_configinfo_configinfo_peizhiguanli": "Configuration management",
  "system_configinfo_configinfo_youxiang": "Email",
  "system_configinfo_configinfo_weixin": "Wechat",
  "system_configinfo_configinfo_daishenpi": "Awaiting approval",
  "system_configinfo_configinfo_daiqueren": "To be confirmed",
  "system_configinfo_configinfo_daizhifu": "To be paid",
  "system_configinfo_configinfo_daichuli": "To be processed",
  "system_configinfo_configinfo_yiwancheng": "Completed",
  "system_configinfo_configinfo_baocunchenggong": "Save successfully",
  "system_download_download_banbenhao": "Version number",
  "system_download_download_daxiao": "Size",
  "system_download_download_jieshao": "Introduction",
  "system_download_download_yingyongjieshao": "Introduction to the Applications ",
  "system_download_download_slcglqxdqyslglxtykqd": "This APP is a corporate business travel management system under Licheng International Travel Company, which is relying on powerful resources, advanced technology, high-quality services and professional management to help many companies optimize business travel, booking and authorization approval procedures.",
  "system_download_download_yonghukeyitongguo": "Users can",
  "system_download_download_xtksdjhjpjdhcpdcxyds": "Quickly do inquiries, reservations, approvals and other services of air tickets, hotels, and train tickets through the APP system, which can make travel management intelligent. So that users do not need borrow money, advance funds, or reimburse travel expenses which can improve user travel satisfaction degree. It truly helps companies reduce consumption costs, simplify the financial reimbursement process, and improve operational efficiency.",
  "system_download_download_zhuyaogongneng": "",
  "system_download_download_àcsrqqfsjdxxcxbydjpj": "Search and book air tickets, hotels, and train tickets by city, date, departure time and other information;",
  "system_download_download_qyyjdpwxygdkjkdphsxy": "Enterprise monthly ticket book (without employee advance payment) and authorize employee management",
  "system_download_download_qingsongchakanguanlidingdanyijiantuipiaogaiqian": "Easily view and manage orders, one-click refund and change;",
  "system_download_download_zcqydcbgkszydgczlhgk": "Support the enterprise's different standard control management. flexible control during the booking process. Help companies implementing travel policies and save costs.",
  "system_feedback_feedback_fankuileixing": "Feedback type",
  "system_feedback_feedback_fankuineirong": "Feedback content",
  "system_feedback_feedback_wltgwmdfwhzlwmwntgfw": "In order to improve our service and quality, we provide you with a dedicated channel for service complaints and suggestions. Feedback to our BOSS as soon as possible!",
  "system_feedback_feedback_shangchuanzhaopian": "Upload photos",
  "system_feedback_feedback_shangchuantupianshuomingkeyigengfangbianwomenlijienindexuqiuo": "Uploading a picture description can make it easier for us to understand your needs",
  "system_feedback_feedback_yibianwomengeininhuifu": "So that we can reply to you",
  "system_feedback_feedback_shoujihao": "Telephone no.",
  "system_feedback_feedback_qitalianxifangshiyouxiang": "Other contact information (email/QQ...)",
  "system_feedback_feedback_qita": "Other",
  "system_feedback_feedback_tijiao": "Submit",
  "system_feedback_feedback_yijianfankui": "Feedback",
  "system_feedback_feedback_shijuetiyan": "Visual experience",
  "system_feedback_feedback_caozuotiyan": "Operation experience",
  "system_feedback_feedback_zhengzaishangchuan": "Uploading ",
  "system_feedback_feedback_shangchuanchenggong": "Upload successfully",
  "system_feedback_feedback_shangchuanshibai": "Upload failed",
  "system_feedback_feedback_qingtianxienindebaoguiyijianhuoshangchuanzhaopian": "Please fill in your valuable comments or upload photos",
  "system_feedback_feedback_tijiaochenggongganxienindefankui": "The submission is successful, thank you for your feedback",
  "system_mall_addinvoice_shanchu": "Delete",
  "system_mall_addtraveller_shanchu": "Delete",
  "system_mall_modules_travelername_xingmingxuyuxiedaichuhangdezhengjianyizhifouzehuiyingxianghangcheng": "The name must be consistent with the travel documents, otherwise it will affect the itinerary",
  "system_mall_modules_travelername_tianxiexuzhi": "Notes",
  "system_mall_modules_travelername_yitianxieshuoming": "Instruction",
  "system_mall_modules_travelername_chengkexingmingxuyudengjisuochizhengjianshangdemingziyizhi": "The passenger's name must be consistent with the travel documents",
  "system_mall_modules_travelername_wqbslchqqblhjsrqzsbz": "To ensure a successful trip, please make sure that the end date of the trip is at least 6 months earlier than the validity of the document. Please confirm to fill in the true and valid document number. The order cannot be modified after submitted.",
  "system_mall_modules_travelername_erxinbanhuzhao": "Current passport",
  "system_mall_modules_travelername_sanjiubanhuzhao": "Expired passport",
  "system_mall_modules_travelername_sigangaotonghangzheng": "Mainland Travel Permit for Hong Kong and Macau Residents",
  "system_mall_modules_travelername_wutaiwantonghangzheng": "Mainland Residents Traveling to Taiwan Permit",
  "system_mall_modules_travelername_liutaibaozheng": "Mainland Travel Permit for Taiwan Residents",
  "system_mall_oftenpassenger_gongsichangke": "Company frequent guest",
  "system_mall_oftenpassenger_gerenchangke": "Personal frequent guest",
  "system_messagenotify_messagenotify_gong": "Total",
  "system_messagenotify_messagenotify_tiaoxiaoxi": "",
  "system_messagenotify_messagenotify_weiduxiaoxi": "Unread message",
  "system_messagenotify_messagenotify_yiduxiaoxi": "Read message",
  "system_messagenotify_messagenotify_zanwuxiaoxi": "No message",
  "system_messagenotify_messagenotify_xiaoxitongzhi": "Message notification",
  "system_messagenotify_messagenotify_quanbuxiaoxi": "Total",
  "system_messagenotify_messagenotify_xitongtongzhi": "Systematic notification",
  "system_messagenotify_messagenotify_xiaoxitixing": "Message reminding",
  "system_messagenotify_notifyitem_xitongtongzhi": "Systematic notification",
  "system_messagenotify_notifyitem_xiaoxitixing": "Message reminding",
  "system_messagenotify_notifyitem_ganggang": "Just now",
  "system_messagenotify_notifyitem_shanchu": "Delete",
  "system_modules_calendar_zhongzhi": "Reset",
  "system_modules_calendar_ri": "Sunday",
  "system_modules_calendar_yi": "Monday",
  "system_modules_calendar_er": "Tuesday",
  "system_modules_calendar_san": "Wednesday",
  "system_modules_calendar_si": "Thursday",
  "system_modules_calendar_wu": "Friday",
  "system_modules_calendar_liu": "Saturday",
  "system_modules_calendar_yuandan": "New Year's Day",
  "system_modules_calendar_qingmingjie": "Ching Ming Festival",
  "system_modules_calendar_laodongjie": "Labor day",
  "system_modules_calendar_guoqingjie": "National Day",
  "system_modules_calendar_chuxi": "Chinese New Year's Eve",
  "system_modules_calendar_chunjie": "Spring Festival",
  "system_modules_calendar_duanwujie": "Dragon Boat Festival",
  "system_modules_calendar_zhongqiujie": "Mid-Autumn Festival",
  "system_user_account_account_jiebang": "Unbind",
  "system_user_businessregister_qiyeyonghuzhuce": "Enterprise user registration",
  "system_user_businessregister_ruguigongsiyishilichengshanglvqianyueqiye": "If your company is the contracted enterprise of Licheng Business Trip",
  "system_user_businessregister_qinglianxinindechalvfuzerenhuoquzhanghaowuzhongfuzhuce": "Please contact the person in charge of business travel to obtain an account, do not register repeatedly",
  "system_user_businessregister_qingshuruninqiyemingcheng": "Please enter your company name",
  "system_user_businessregister_qiyemingcheng": "Company name",
  "system_user_businessregister_shoujihaohuoyouxiangzhuce": "Telephone number or email registration",
  "system_user_businessregister_shoujihao": "Telephone number",
  "system_user_businessregister_qingshuruyanzhengma": "Please enter verification code",
  "system_user_businessregister_yanzhengma": "Verification code",
  "system_user_businessregister_qingshuruguiqiyesuoshuhangye": "Please enter the industry of your company",
  "system_user_businessregister_qiyehangye": "Company Industry",
  "system_user_businessregister_qingshuruguiqiyediqu": "Please enter your company address",
  "system_user_businessregister_qiyediqu": "Company address",
  "system_user_businessregister_qingtianxielianxirenxingming": "Please enter the contact name",
  "system_user_businessregister_lianxiren": "The contact name",
  "system_user_businessregister_zhucezhanghao": "Register an account",
  "system_user_businessregister_qingshezhidenglumima": "Please set password",
  "system_user_businessregister_denglumima": "Password",
  "system_user_businessregister_zaicishurumima": "Enter the passphrase again",
  "system_user_businessregister_querenmima": "Confirm Password",
  "system_user_businessregister_tongyi": "Agree",
  "system_user_businessregister_fuwuxieyi": "Service Agreement",
  "system_user_businessregister_xiayibuyanzheng": "Next, verify",
  "system_user_businessregister_wancheng": "Complete",
  "system_user_businessregister_ruzhucechuxianwenti": "If there is any problem with registration",
  "system_user_businessregister_qingboda": "Please ",
  "system_user_businessregister_lianxikefuweinijieda": "Contact customer service to answer for you",
  "system_user_businessregister_zhuce": "Registered",
  "system_user_businessregister_gongsimingchengbunengkong": "Company name cannot be empty",
  "system_user_businessregister_dangqianshoujihaoyibeizhuce": "The current mobile phone number has been registered",
  "system_user_main_peizhiguanli": "Configuration management",
  "system_user_modules_authorizat_qiyezhanghaoyouxiangshoujihao": "Enterprise account/email/phone number",
  "system_user_modules_authorizat_qingshuruzhanghu": "Please enter account",
  "system_user_modules_authorizat_buqufendaxiaoxie": "Case-insensitive",
  "system_user_modules_authorizat_qingshuruyanzhengma": "Please enter verification code",
  "system_user_modules_authorizat_lijibangding": "Bind now",
  "system_user_modules_authorizat_lijizhuce": "Register now",
  "system_user_modules_authorizat_zhanghaobangding": "Account binding",
  "system_user_modules_authorizat_shoujiyanzhengbangding": "Mobile phone binding verification",
  "system_user_modules_ordinary_lijizhuce": "Sign in",
  "system_user_modules_ordinary_denglu": "Register",
  "system_user_modules_ordinary_xiugaichushimima": "Change initial password",
  "system_user_modules_password_shezhimima": "Set password",
  "system_user_modules_password_xiacidenglutixingwo": "Remind me the next time I log in",
	"system_user_modules_yinsishezhi": "Privacy settings",
  "system_user_modules_gexinghuatuijian": "Personalized recommendation",
	"system_user_modules_gexinghuaguanbi": "After closing, you will no longer be able to receive personalized content recommendations. It is recommended to enable it so that you can receive personalized content that meets your needs.",
  "user_resetpwd_mobilevalidate_yanzhengguize": "Validation rules",
  "user_resetpwd_verifyidentity_zhaohuimima": "Retrieve password",
  "user_resetpwd_verifyidentity_dengluming": "Login name",
  "user_resetpwd_verifyidentity_zhucehuobangdingdeshoujihaohuoyouxiang": "Registered or bound mobile phone number or email",
  "user_resetpwd_verifyidentity_haiwaishoujiqinganguojiadaimashoujihaomadegeshishururu": "For overseas mobile phones, please enter the format of \"country code-mobile phone number\", such as: 79-66666666",
  "user_resetpwd_verifyidentity_xiayibu": "Next step",

  "user": { "companyName": "Licheng Business Trip" },
  "router": { "home": "Home", "trip": "Trip", "my": "My " },
  "bill": { "myOrder": "My booking" },
  "mall": {
    "OnBusiness": "For business",
    "OnPersonal": "For personal",
    "btriprule": "Travel rules",
    "demandorder": "Demand list",
    "allprice": "Full price",
    "discount": "Off",
    "GivenName": "English given name",
    "Surname": "English Surname",
    "selectedseat": "Seat selected",
    "noselectseat": "Seat Unselected",
    "takeOff": "T,ake off",
    "FillInfo": "Fill in instructions",
    "ExpiryDate": "Validity",
    "StartTime": "Starting time",
    "EndTime": "End Time",
    "ToProcessDate": "Departure date",
    "backTracking": "Return date",
    "sharing": "Shared",
    "AirplaneModelTxt": "Airplane Model",
    "ticketfeeFloat": "This price does not include airport construction fee and tax",
    "peopleTypeExplain": "Booking instructions of Child and infant ",
    "bookingTicketExplain": "If you need to book a child or infant ticket, please contact our customer service.",
    "onlySeeDirect": "Only direct flights",
    "hiddenSharedFlight": "Hide shared flights",
    "ActualCarrier": "Actual carrier",
    "stayTxt": "Stop",
    "turnTxt": "Transfer in",
    "priceRemarks": "The following charge is the average price of an adult or a child or an infant.",
    "AgreementPrice": "Business Recommendation",
    "tax": "Tax",
    "trainHolderKeyWords": "Domestic train ticket",
    "bookingRemarks": "You can only book a maximum of 5 passengers at a time",
    "beginTxt": "Departure",
    "passTxt": "Pass",
    "endTxt": "Arrival",
    "StandingOrder": "Station order",
    "stationName": "Station name",
    "arrivalTimeTxt": "Arrival time",
    "departTimeTxt": "Departure time",
    "departDate": "Departure date",
    "arrivalDate": "Arrival date",
    "hotelHolderKeyWords": "Please enter keywords/hotel name, etc.",
    "HotelRemarks": "Please do not book over 5 rooms or 20 nights. If you have special needs please contact with customer service.",
    "TrainRemarks": "NOTICE: Booking time is from 7:30 am to 22:30 pm. You can book,change and refund tickets more than 30 minutes prior to departure. The tickets within 24 hours should be paid in 10 minutes. The tickets beyond 24 hours should be paid in 25 minutes.",
    "NoTrainSearch": "We don't provide train service in the current time",
    "mapTxt": "Map/navigation",
    "detailsOrFacilities": "Details/Amenities",
    "noSooner": "No breakfast",
    "breakfast": "Breakfast",
    "breakfastTxt": "With breakfast",
    "noCancellation": "Non-refundable",
    "timeToCancel": "Free cancellation before",
    "withWindow":"With Window",
    "RoomsTxt": "Number of rooms",
    "hotelUnit": "Late",
    "checkInTxt": "Check in",
    "checkOutTxt": "Check out",
    "checkInDate": "Check-in date",
    "checkOutDate": "Check out date",
    "Frequenter": "Frequent guest",
    "Temporary": "Temporary guest",
    "TemporaryInformation": "Temporary guest information",
    "addFrequenter": "Add frequent guest",
    "addTemporary": "Add temporary guest",
    "TravelStandard": "Traveling Expenses Standard",
    "hightToLow": "High to low",
    "lowToHight": "Low to high",
    "morningToNight": "Earliest to latest",
    "nightToMorning": "Latest to earliest",
    "starLevelTxt": "Star rating",
    "filtrateTxt": "Filter",
    "timeTxt": "Time",
    "fromTo": "From",
    "contactNumber": "Contact Number",
    "conformToRules": "Conforming rules",
    "breakToRules": "Violating policy",
    "unlimited": "No limitation",
    "beforeDay": "The previous day",
    "afterDay": "The following day",
    "adequateTxt": "Enough",
    "Remaining": "Only {0} left",
    "taxesTxt": "Tax",
    "BackTorule": "Policies",
    "trainamendrule": "15+ days prior to departure: free 48 hours-15 days prior to departure: 5% of ticket price 24-48 hours prior to departure: 10% of ticket price Within 25 hours before departure: 20% of ticket price.",
    "booking": "Book",
    "onlinePay": "Prepay online",
    "departTxt": "Departure",
    "arrivalTxt": "Arrival",
    "sheet": "Ticket",
    "NoTicket": "Sold out",
    "orderFilltitle": "Order filling",
    "tripInfosTitle": "Passenger information",
    "BookingInformation": "Booking notice",
    "tripInfosRemarks": "To ensure a successful trip，please make sure that the passenger's name must be consistent with the travel documents",
    "addTraveller": "Add a passenger",
    "UserName": "Name",
    "contactInfosTitle": "Contact information",
    "RemarkInfosTitle": "Note",
    "contacts": "Contact person",
    "Phone": "Telephone",
    "Email": "E-mail",
    "InstructTitle": "Deduction instructions",
    "InstructContent": "According to the payment method we will pre-authorize your card or deduct room fee. If the order is not confirmed, we will release the pre-authorization or give you a full refund to your account. The order can't be changed or cancelled. You will be billed for the first night's room charge if you don't check in. If you check out in advance you will be billed for the day's room charge.",
    "SpecialTipsTitle": "Special Requests",
    "SpecialTipsContent": "The earliest check-in time is 14:00. The check-out time is 12:00. If you arrive before this time or departure after this time, you may need subject to a fee.",
    "travelInformationTitle": "Travel information",
    "CostCenter": "Cost center",
    "TravelPurpose": "Travel purpose",
    "ProjectCode": "Project code",
    "contraryReason": "Reason of violations",
    "ViolateTravelRules": "Violating travel rules",
    "SpecialRequirement": "Special needs",
    "SpecialRequirementTips": "Special needs remarks",
    "specialRequirementContent": "We will try our best to coordinate with your special requirements. If it cannot be satisfied, we will not notify you separately, please understand",
    "otherRequirement": "Other demands",
    "consentAgreement": "Click Submit means that you have read and agreed",
    "importantTerms": "Booking instructions and important terms",
    "BookingHint": "In order to support the green environmental protection, be default we provide electronic contract. If you need to sign a paper contract, please call customer service.",
    "CostDetails": "Price Details",
    "payTotalPrice": "Total",
    "totalPrice": "Total",
    "roomUnit": "Room",
    "nightUnit": "Night",
    "peopleUnit": "Person",
    "details": "Details",
    "CustomerService": "Contact Customer Service",
    "SubmissionOrPayment": "Submit/Pay",
    "frequentlnformationTitle": "Passenger information",
    "TravellerTitle": "Passenger Name",
    "EnglishName": "English name",
    "LastName": "English Surname",
    "firstName": "English given name",
    "NameOrIdCardTips": "To ensure a successful trip，please make sure that the passenger's name must be consistent with the travel documents",
    "CertificateInformatTitle": "ID informaiton",
    "ExpireDate": "ID validity",
    "otherInfosTitle": "Other information",
    "Sex": "Gender",
    "Birthday": "Date of birth",
    "Nationality": "Nationality",
    "optionalCard": "Frequent flyer card (optional)",
    "reminderInfos": "To ensure a successful trip, please make sure that the end date of the trip is at least 6 months earlier than the validity of the document. Please confirm to fill in the true and valid document number. The order cannot be modified after submitted.",
    "addOrEditTraveller": "Add or edit passenger",
    "AllOrder": "All orders",
    "orderStatus": "Order Status",
    "departTime": "Departure time",
    "orderDetail": "Order details",
    "CancelOrder": "Cancel order",
    "CancelRefund": "Cancel refund",
    "CancelChange": "Cancel change",
    "ApprovalRefused": "Rejected",
    "ApproveSucc": "Approved",
    "PayNow": "Pay now",
    "Refund": "Refund",
    "RefundHotel": "Check out",
    "RefundGroup": "Refund group",
    "Change": "Change",
    "SubmitOrder": "Submit Order",
    "PriceDetail": "Price details",
    "CheckOrderProgress": "Check order progress",
    "flightInformation": "Flight information",
    "orderNumber": "Order number",
    "BookingTime": "Booking time",
    "First": "序数",
    "Journey": "Trip",
    "few": "Room",
    "Level": "Level",
    "BackToChangeTips": "The final amount is subject to review. If you have any questions, please call customer service",
    "pleaseChoose": "Please choose",
    "ThePassengers": "ThePassengers",
    "Transfer": "Stopover",
    "Flight": "Flight",
    "RefundRoomsDate": "Check out time",
    "TheReason": "Reason",
    "TheTrain": "Train",
    "hour": "Hour",
    "minute": "Minute",
    "Gym": "Gym",
    "district": "Administrative area",
    "business": "Administrative area",
    "ThePassengerInformation": "Passenger information",
    "NewTrainInformation": "New train information",
    "OriginalTrainInformation": "Original train information",
    "NewFlightInformation": "New flight information",
    "OriginalFlightInformation": "Original flight information",
    "NextStep": "Next step",
    "ChangeDate": "Change date",
    "SelectChangeFlight": "Please select a changed flight",
    "SelectRefundFlight": "Please select the flight for refund",
    "SelectChangeTrain": "Please select the changed passenger",
    "SelectRefundTrain": "Please select the refunded passenger",
    "SelectRefundHotel": "Please select the hotel to check out",
    "SelectChangeDate": "Please select a date to change",
    "Department": "Department",
    "ApprovalStatus": "Approval Status",
    "ConfidentialInformation": "Credential information",
    "TradeInformation": "Trading Information",
    "Insurance": "Insurance",
    "Home": "Home",
    "Stroke": "Trip",
    "Me": "My",
    "TravelApproval": "Travel approval",
    "TravelRulesName": "Travel rules",
    "MinimumPriceBase": "Lowest price standard",
    "RealFlightControl": "Management of real time flight",
    "AdvanceBookingTime": "Advanced booking time",
    "ClassLimit": "Class limitation",
    "SeatClassLimit": "Class limitation",
    "AgreementAirlinePriority": "Contract tickets first",
    "AgreementHotelPriority": "Contract hotels first",
    "MaximumAmountConsumption": "Upper limitation of consumption",
    "ApprovalName": "Travel rules",
    "Other": "Other",
    "FirstClassCity": "First-tier city",
    "SecondaryCity": "Second-tier city",
    "ThreeLevelCity": "Third-tier city",
    "SeatSelectionService": "Seat select",
    "Bezel": "Window",
    "Aisle": "Aisle",
    "NewContacts": "Add contact",
    "AdditionalInvoiceInformation": "Add/Edit invoice information",
    "InvoiceInformation": "Invoice Information",
    "InvoiceTitle": "Invoice",
    "TariffItem": "Tax number",
    "SetDefaultContacts": "Set default contact",
    "ConsigneeAddress": "Recipient address",
    "NewCommonAddresses": "Add frequently used addresses",
    "default": "Default",
    "City": "City",
    "Address": "Address",
    "Postcode": "Postcode",
    "AddCommonAddresses": "Add/Edit frequently used addresses",
    "DepartureTime": "Departure time",
    "Airport": "Airport",
    "ShippingSpace": "Class ",
    "AirlineCompany": "Airline",
    "150OrLess": "Less than 150",
    "150And300": "￥150-300",
    "300And450": "￥300-450",
    "450And600": "￥450-600",
    "600OrMore": "More than 600",
    "TwoStarsOrLess": "Two stars and below",
    "ThreeStar": "Three stars / comfortable",
    "FourStar": "Four stars / upscale",
    "FivesStar": "Five stars / luxurious",
    "Apartment": "Apartment",
    "Inn": "Inn",
    "FamilyInn": "Family Inn",
    "YouthHostel": "Youth Hostel",
    "CoupleHotel": "Love hotel",
    "GardenCourtyard": "Garden courtyard",
    "SeaView": "Sea view",
    "Farmhouse": "Farmhouse",
    "HotSpringHotel": "Hot Spring Hotel",
    "GolfHotel": "Golf Hotel",
    "Siheyuan": "Courtyard",
    "Villa": "Villa",
    "PartyCooking": "Party cooking",
    "BusinessTtravelHome": "Business Travel Home",
    "LeisureMood": "Casual mood",
    "SeeDoctor": "See doctor",
    "VacationLeisure": "Vacation leisure",
    "TrainAndLearn": "Training and learning",
    "GetTogether": "Party ",
    "HoneymoonTrip": "Honeymoon",
    "boutiqueHotel": "Boutique Hotel (Designer Hotel)",
    "FreeWifi": "Free wifi",
    "FreeParking": "Free parking lot",
    "IndoorPool": "Indoor swimming pool",
    "OutdoorPool": "Outdoor swimming pool",
    "service": "Gym",
    "BusinessCenter": "Business center",
    "MeetingRoom": "Meeting room",
    "HotelRestaurant": "Hotel restaurant",
    "MorningCall": "Morning Call",
    "LuggageStorage": "Luggage storage",
    "TwinBed": "Double bed",
    "BigBed": "Big bed",
    "FreePickUpService": "Free pick-up service",
    "Price": "Price",
    "StarLevel": "Star rating",
    "Specialtie": "Features",
    "Service": "Facilities",
    "DetailsOrFacilities": "Details/Facilities",
    "HotelDetail": "Hotel details",
    "ModelSelection": "Model selection",
    "HighSpeedRail": "High-speed train(G/C)",
    "MotorCar": "High-speed train(D)",
    "Ordinary": "Common(Z/T/K)",
    "DepartureOrArrival": "Departure/Arrival Station",
    "Date": "Date",
    "Status": "Status",
    "OldSystem": "Please view by PC version ",
    "Welcome": "Welcome",
    "PleaseLogIn": "Please sign in",
    "FlightTips": "Low-cost air tickets, comfortable travel",
    "HotelTips": "Exclusive stay, exclusive for business travel",
    "TrainTips": "One-click lightning ticket issuance",
    "TourTips": "Featured special offer tours",
    "Invoice": "Invoice",
    "InvoiceType": "Invoice type",
    "Identifier": "Identifier",
    "TicketInquiry": "Ticket inquiry",
    "TrainInquiry": "Train inquiry",
    "HotelInquiry": "Hotel inquiry",
    "ConsumerHotline": "Customer Service",
    "WeChatService": "WeChat Customer Service",
    "TravelPolicy": "Travel policy",
    "EditData": "Edit information",
    "RecommendFlight": "Recommended flight",
    "voyageinfos": "flight information",
    "passinfos": "Passenger information",
    "passnum": "Number of passengers",
    "cabinlevel": "Class of cabin",
    "consumertype": "Passenger Type",
    "sui": "year old",
    "twosui": "Under two years old",
    "firstairway": "Preferred airline",
    "demandprobtip": "If you have a problem with the submission, please consult:",
    "submit": "submit",
    "remark": "remark",
    "email": "email",
    "contact": "Contact person",
    "phoneno": "Mobile",
    "contactinfo": "Contact details",
    "normal": "ordinary",
    "student": "student",
    "newimmigrant": "New immigrants",
    "worker": "laborservice",
    "adult": "adult",
    "child": "child",
    "infant": "baby",
    "departdate": "Departure time",
    "arrivedate": "arr time",
	  "departcity": "Departure City",
    "arrivecity": "Arrival City",
    "selectdate": "Select date",
    "delete": "Delete",
    "addvoyage": "Add flight",
    "notificationMessageFlight":
    "Notice: if you need, you can click here to enter the international demand list.To meet any of your travel needs You may also call:",
    "noVoyage":'Voyage without satisfaction？',
    "foundRequirement":'Create requirement sheet',
    "Hotline": "Hotline consultation.",
    "OriginalFlight": "Original flight",
    "More": "More",
    "MoreInfo": "More information",
    "Hidden": "Hide",
    "JetFuel": "Including Airport construction fee",
    "Booking": "Booking",
    "CurrentPosition": "Current position",
    "Room": "Room",
    "SquareMeters": "Square meter",
    "CanLive": "Can live",
    "Floor": "Floor",
    "Layer": "Floor",
    "ServiceFee": "Service charge",
    "InsurancePremium": "Insurance premiums",
    "Yuan": "",
    "ContactHotel": "Contact hotel",
    "After": "After",
    "Before": "Before",
    "For": "For",
    "DueTo": "Booked at",
    "ViolationPolicy": "Violating rules",
    "CompliancePolicy": "Conforming rules",
    "BusinessInformation": "Business Travel Information",
    "Within": "Within",
    "RefuseReason": "Approval notes",
    "Against": "Violate",
    "Policy": "Policy",
    "DetailedReason": "Reasons",
    "Wait": "Await",
    "Approval": "Approve",
    "Breach": "Violate",
    "AirlineAuditStandards": "Subject to the latest airline regulations, you can contact customer service ",
    "ConfirmOrder": "Confirm Order",
    "FlightInformation": "Flight information",
    "Voyage": "Flight",
    "DeparturePlace": "Departure",
    "ArrivePlace": "Arrival",
    "AddVoyage": "Add itinerary",
    "PassengersNumbers": "Number of passengers",
    "ShipType": "Class type",
    "PassengersType": "Passenger Type",
    "ShipCompany": "Preferred Airlines",
    "Remarks": "Remarks",
    "PackUp": "Show less",
    "Show": "Show more",
    "DocumentType": "ID Type",
    "CardNo": "Id number",
    "InvoiceRole": "Invoice role",
    "BankName": "Bank name",
    "BankAccount": "Bank Account",
    "RegisteredAddress": "Registered address",
    "RegisteredPhone": "Registered phone",
    "ChangeReason": "Reason of change",
    "VoucherNumber": "Voucher number",
    "CancelReason": "Reason of cancel",
    "ChildInfantBooking": "Child and infant booking instructions",
    "boyin": "Boeing",
    "kongke": "Airbus",
    "AppropriationBudget": "Budget",
    "Attendance": "Number of participants",
    "HostPlace": "Host Place",
    "Destination": "Destination",
    "ParticipantsNumber": "The number of participants",
    "ActivityBudget": "Activity budget",
    "AmountPaid": "Amount to be paid",
    "ConfirmPayment": "Confirm payment",
    "Pay": "Pay",
    "PriceTxt": "Price",
	  'ReserveHint':'It is a non-connecting flight. If one of the flights is changed, the passenger who needs to cancel the other flight will bear the corresponding cancellation fee.',
    'EmptyData':'No results meeting the criteria were found. We suggest you change the date or city and try searching again.',
    'TicketFare':'TicketFare',
	  'BuildFare':'BuildFare',
	  'FuelFare':'FuelFare',
	  'TaxFare':'TaxFare',
  },
  "placeholders": {
    "UserID": "Please enter user name",
    "Password": "Please enter password",
    "UserPhone": "Please enter phone number",
    "contacts": "Please fill in the contact name",
    "Email": "Used to receive confirmation",
    "CostCenter": "Please select cost center",
    "TravelPurpose": "Please select the travel purpose",
    "ProjectCode": "Please enter project code",
    "CauseName": "Please choose the reason of violations",
    "CauseDetails": "Please write the details of violations reason",
    "searchTraveller": "Please enter your name ",
    "SearchZones": "Chinese or Pinyin for cities and stations",
    "UserName": "Match the passenger's ID name",
    "LastName": "Such as: 张飞, fill in: ZHANG",
    "firstName": "Such as: 张飞, fill in: FEI",
    "CardNo": "ID number",
    "Phone": "Please enter the phone number",
    "RecipientAddress": "Please enter recipient address",
    "RecipientPostcode": "Please enter the recipient's zip code",
    "OriginalPassword": "Please enter the original password",
    "NewPassword": "Please enter a new password",
    "AffirmNewPassword": "Please confirm your password",
    "CompanyName": "Please enter company name",
    "SelectCity": "Please choose the city",
    "Industry": "Please enter industry",
    "Account": "Please enter your phone number or email",
    "VerificationCode": "Please enter verification code",
    "DynamicCode": "Please enter dynamic code",
    "RegisterPhone": "Please register or bind your mobile phone number!",
    "Invoice": "Invoice",
    "InvoiceType": "Invoice type",
    "Identifier": "Required, Taxpayer's registration number",
    "RefusalCause": "Please enter the reason for rejection",
    "CaseInsensitive": "Case-insensitive",
    "MessageAuthenticationCode": "Message verification code",
    "DeparturePlace": "Departure",
    "ArrivePlace": "Arrival",
    "ContactEmail": "Please enter your email",
    "Remarks": "Please enter note",
    "ShipCompany": "Preferred Airlines",
    "BankName": "Bank name",
    "BankAccount": "Bank Account",
    "RegisteredAddress": "Registered address",
    "RegisteredPhone": "Register phone",
    "TrainDetailReason": "Train details",
    "PeopleNumber": "Please enter the number of people",
    "AppropriationBudget": "Please enter budget",
    "ContactNumber": "Please enter your phone number",
    "ContactRemarks": "Tell us your most convenient contact time and method, and let us reply you at the most appropriate time."
  },
  "system": {
    "Customer": "Online service",
    "EmailNotification": "E-mail notification",
    "servicePhone": "",
    "Company": "Licheng Business Trip",
    "Name": "Licheng Business Trip",
    "contacts": "Contact information",
    "HowToCall": "What should everyone call you",
    "PerfectInformation": "Please complete the mobile number",
    "BindingPhone": "Bind phone",
    "BindingEmail": "Bind mailbox",
    "AccountAssociated": "Account association",
    "UpdatePassword": "Change login password",
    "Language": "Language",
    "Chinese": "Chinese",
    "English": "English",
    "Japanese": "Japanese",
    "ExitLogin": "Log out",
    "WeChat": "WeChat",
    "ImmediatelyBinding": "Bind now",
    "Password": "Password",
    "OriginalPassword": "Original password",
    "NewPassword": "New password",
    "AffirmNewPassword": "Confirm password",
    "ChangePassword": "Change Password",
    "EditPersonalInformation": "Edit profile",
    "CompanyName": "Company Name",
    "Industry": "Industry",
    "Account": "Account",
    "VerificationCode": "Verification code",
    "DynamicCode": "Dynamic code",
    "RegisterNow": "Register now",
    "Register": "Registered",
    "UserRegister": "Individual registration",
    "CompanyRegister": "Company registration",
    "ServiceAgreement": "Agree to \"Licheng Travel Service Agreement\"",
    "SendDynamicCode": "Send dynamic code",
    "Sent": "Has been sent",
    "LoginTxt": "Sign in",
    "DynamicPasswordLogin": "Dynamic password login",
    "ForgetPassword": "Forget password",
    "Integral": "Points",
    "AllOrders": "All orders",
    "Obligation": "Awaiting Payment",
    "NotToTravel": "Upcoming",
    "ToApproval": "Awaiting approval",
    "TicketInformation": "Ticket information",
    "OrderInformation": "Order information",
    "OrderID": "Order number",
    "TradeID": "Transaction number",
    "TradeAmount": "The total amount of orders",
    "CollectingCompany": "Receivables Company",
    "PaymentWays": "Payment method",
    "Payment": "Pay",
    "ThePassengerInformation": "Passenger information",
    "PassWordLogin": "Password login",
    "CodeLogin": "Verification code login",
    "Notice": "Notice",
    "RecentOrders": "Recent itinerary",
    "Reserved": "Awaiting confirmation",
    "CustomerService": "Customer service",
    "Sell": "Sales",
    "ContactUs": "Contact us",
    "Call": "Call",
    "ServiceDept": "Customer Service Department",
    "MyOrder": "My booking",
    "ApprovalDispose": "Approval processing",
    "RetrievePwd": "Easy to log in or retrieve password",
    "ElectronicBills": "Easy to receive electronic bills",
    "ApprovalAccredit": "Approval authorization",
    "AboutUs": "About us",
    "TestGetCode": "Get verification code",
    "PhoneHint": "You can reset the password through a valid binding mobile phone.",
    "EmailHint": "You can reset the password through a valid bound email address.",
    "LoginPassword": "Login password",
    "ResetPassword": "Reset Password",
    "EnterAccount": "Enter account",
    "PhoneVerification": "Phone verification",
    "EmailVerification": "E-mail verification",
    "SetBinding": "Set binding",
    "Input": "Enter",
    "Effective": "Effective",
    "Verify": "Verification",
    "NextStep": "Next step",
    "RemarkString": "Time limitation of Refund and change ",
    "RefundFee": "Cancellation Fee ",
    "Cabinfee": "Change Fee of same class",
    "ReimburseInfo": "Reimbursement information",
    "BaggageAllowance": "Baggage Allowance",
    "BackChangeRemark": "Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
    "PartRoute": "Some routes",
    "PartHotel": "Some hotels",
    "IsSaveCustomers": "Save to frequent guest or not",
    "EmployeeRights": "Employee permissions",
    "DateGranted": "Grant date",
    "ExpiryDate": "Expiration date",
    "AddApproval": "Add/modify approval",
    "AddApprovals": "Add approval",
    "DownloadInstall": "Download and install",
    "TopRightCorner": "Please click on the upper right corner",
    "BrowserOpen": "Select to open in browser",
    "CannotDownloaded": "Cannot download apps in WeChat/QQ",
    "CompanyProfile": "Company Overview",
    "CompanyProfileContent": "The official website of Shanghai Lichengtrip (www.lichengtrip.net) is affiliated to Shanghai Lichengtrip Ticketing Co., Ltd. The company is headquartered in Shanghai, China. The headquarter office is located in Xindongfang International Business Center, Changning District, Shanghai which is close to Jingan Temple, Caojiadu and other business centers. The company has created call center, general manager's office, finance department, ticket settlement department, international department, domestic counterpart department, customer service department, training department, commerce department, operation center and other corresponding departments. It is a large-scale civil aviation service company with a wide range of sales, a large scale of service, and strong comprehensive strength in Shanghai.",
    "FutureProspects": "Future prospect",
    "FutureProspectsContent": "In the 21st century with the rapid development of Internet technology, the business travel distribution system developed by Shanghai Licheng and scientific research units uses advanced technology with independent intellectual property rights to serve all aspects of people’s lives in the world with convenient and fast streamlined projects, allowing everyone to live on the Internet Ordinary people in the society have the opportunity to become the trend of the Internet economy. Make them feel the perfect integration of the excellent traditional culture of the Chinese nation and the modern democratic lifestyle in the online life experience every second, feel the real humanistic care and the continuous enrichment and improvement of material life, and promote the network society Healthy, harmonious and stable development, dedicated to all the enthusiasm and wisdom of Licheng people! 2016 is a time for Licheng to usher in a higher development. With innovation and enterprising as the driving force, we will further accelerate the speed of development and improve the quality of development. With international and domestic air ticket sales as the main body, vacation bookings are simultaneously implemented, the implementation of a comprehensive development strategy, and efforts to promote informatization, Build an information platform.",
    "ManagementTeam": "Close and sophisticated management team",
    "ManagementTeamContent": "The perfect combination of resource cooperation, management skills, and business experience of Shanghai Licheng's management team, as well as close and close cooperation between the teams, ensure the company's rapid and steady development. Our senior management team has gathered many years of experience in business operation and management in the international IT industry, tourism and financial industries; the middle management team has brought together China’s IT industry, aviation agency industry and tourism industry, ensuring the scale of services and resources Management policy.",
    "TechnicalService": "Technology leadership and service",
    "TechnicalServiceContent": "Licheng has always regarded technological innovation as the source of vitality for the company, and spared no effort in enhancing R&D capabilities. Licheng has established a complete set of modern service system, driven by innovation and enterprising, to further accelerate the speed of development and improve the quality of development, with international and domestic air ticket sales as the main body, hotel reservations and vacation bookings simultaneously.Licheng implement a comprehensive development strategy, strive to promote information And build an information platform.",
    "AboutUsContent": "Telephone"
  },
  "share": {
    "hot": "Popular recommend ",
    "calendarDataTitle": "Select date",
    "calendarDataExplain": "The query date is the departure date",
    "cancelTxt": "Cancel",
    "confirmTxt": "Confirm",
    "pullUpLoadMoreTxt": "Load more",
    "pullUpLoadNoMoreTxt": "No more",
    "RefreshTheSuccess": "Refresh successfully",
    "Save": "Save",
    "Add": "Add ",
    "QueryBtn": "Search",
    "SubmitBtn": "Submit",
    "AmendBtn": "Modify",
    "FinishBtn": "Complete",
    "fail": {
      "CancelOrder": "Please choose to cancel the order",
      "RefundOrder": "Please choose to cancel the refund order",
      "selectTraveller": "Please select a passenger!",
      "minPrice": "Your choice is not a recommended flight or class. Are you sure you want to continue booking?",
      "CostCenter": "Please enter a cost center!",
      "TravelPurpose": "Please enter the purpose of the trip!",
      "EnglishName": "The passenger has no English name!",
      "RefundJourney": "Please select the itinerary which you need to refund!",
      "RefundReason": "Please select the reason you need to refund!",
      "RefundTraveller": "Please select the passenger you need to refund!",
      "ChangeJourney": "Please select the itinerary you need to change!",
      "ChangeTraveller": "Please select the passenger you need to change!",
      "ChooseAnotherFlight": "Please choose another airline's flight!",
      "TheCorrectName": "Please enter the correct surname and given name!",
      "UsreNameRepetition": "Passenger name cannot be repeated!",
      "RegisterPhone": "Please register or bind your mobile phone number!",
      "VerificationCode": "Please enter verification code",
      "DynamicCode": "Please enter dynamic code",
      "PassengerSurname": "Please enter passenger surname",
      "PassengerName": "Please enter passenger given name",
      "RefusalCause": "Please fill in the reason for rejection!",
      "PhoneBinding": "The bound mobile phone number cannot be empty",
      "EmailBinding": "The bound email cannot be empty",
      "Phone": "Please enter a valid phone number",
      "Email": "Please enter your vaild email",
      "VerificationTime": "The verification code can only be obtained every 60s",
      "Account": "Please enter account Username",
      "AccountEmpty": "Account Username cannot be empty",
      "PasswordEmpty": "Password can not be empty",
      "PassengersNumbers": "The number of passengers has reached its limit, please contact customer service",
      "ManyPeople": "If there are too many passengers, please contact customer service for group purchase",
      "ChangeReason": "Change reason cannot be empty",
      "SeatNumbers": "The number of passengers exceeds the number of seats selected",
      "SelectSeat": "Please select a seat for the selected passenger"
    },
    "succ": {
      "SaveSucc": "Save successfully!",
      "CancelSucc": "Cancel successfully",
      "ApprovalRefused": "Approval rejected!",
      "ApproveSucc": "Approved!",
      "RefundSucc": "The refund application is submitted successfully",
      "ChangeSucc": "The change application is submitted successfully!",
      "RegisteredSucc": "Registration success!",
      "LoginSucc": "Sign in successfully!",
      "ChangePasswordSucc": "Password reset successfully!",
      "VerificationSucc": "Verification code sent successfully",
      "AddSucc": "Added successfully",
      "ModifySucc": "Modified Successfully ",
      "DeleteSucc": "Deleted successfully ",
      "WeChat": "WeChat unbind successfully"
    },
    "confirm": {
      "YesOrNoDelect": "Confirm delete",
      "CreateOrder": "The order is created successfully, you are welcome to follow the order progress in the order details at any time",
      "ThankRemarks": "Thank you for your long-term support and trust in Licheng Business Trip. For improving the user experience, Licheng Business Trip 2.0 system officially launched at 9:00 am on 30th of oct in 2018. Users can update automatically through AppStore. For Android system  please contact our customer service. Emergency contact number:15901610043. Thank you."
    },
    "loading": {
      "load": "Processing",
      "creatOrder": "Order is being created",
      "PriceCalculation": "Price calculating"
    }
  },
  "Categorys": {
    "Young": "Adult",
    "Enfant": "Child",
    "Infant": "Infant",
    "economyClass": "Economy class",
    "buissenesClass": "Business class",
    "firstClass": "First class",
    "OnBusiness": "For business",
    "OnPersonal": "For personal",
    "FlightService": "Air tickets",
    "HotelService": "Hotel",
    "TourService": "Tourism",
    "TrainService": "Train",
    "SingleVoyage": "One Way",
    "RoundVoyage": "Round way",
    "WaitBooking": "To be booked",
    "WaitConfirm": "To be confirmed",
    "WaitPayment": "To be paid",
    "WaitDispose": "To be processed",
    "Finished": "Completed",
    "Canceled": "Cancelled",
    "Rejected": "Returned",
    "Cannot": "Invalid",
    "WaitApprove": "Awaiting approval",
    "Discrete": "Split",
    "WaitSubmit": "Awaiting submit",
    "WaitRefund": "Awaiting refund",
    "Male": "Male",
    "Female": "Female",
    "IDCard": "ID ",
    "PassportCard": "Passport",
    "StudentCard": "Student card",
    "OfficerCard": "Officer ID",
    "HKMpermit": "Mainland Travel Permit for Hong Kong and Macau Residents",
    "TaiWpermit": "Mainland Residents Traveling to Taiwan Permit",
    "OtherCard": "Other",
    "Company": "The company",
    "User": "User",
    "HotelFare": "Room rate",
    "TicketFare": "Fare",
    "MobileAuth": "Phone account",
    "EmailAuth": "Email address",
    "AccountAuth": "Account password",
    "WeixinAuth": "WeChat authorization",
    "DynamicAuth": "Dynamic password",
    "MessageNotify": "SMS notification",
    "MailNotify": "E-mail notification",
    "WechatNotify": "WeChat notification",
    "AppNotify": "App notification",
    "Normal": "Common",
    "OverseasStudent": "Student",
    "Worker": "Workers",
    "Immigrant": "New immigrants",
    "1138Categorys": "ID ",
    "1139Categorys": "Passport",
    "1140Categorys": "Student card",
    "1141Categorys": "Officer ID",
    "1298Categorys": "Mainland Travel Permit for Hong Kong and Macau Residents",
    "1299Categorys": "Mainland Residents Traveling to Taiwan Permit",
    "1142Categorys": "Other",
    "AmendingFlight": "Partial refunding",
    "ChangeingFlight": "Partial changing",
    "AmendingTrain": "Partial refunding",
    "ChangeingTrain": "Partial changing",
    "AmendingHotel": "Partial refunding",
    "ChangeingHotel": "Partial changing",
    "AmendingTour": "Partial withdrawal",
    "ChangeingTour": "Partial changing",
    "AmendedFlight": "Partial refund",
    "ChangeedFlight": "Partial change",
    "AmendedTrain": "Partial refund",
    "ChangeedTrain": "Partial change",
    "AmendedHotel": "Partial refund",
    "ChangeedHotel": "Partial change",
    "AmendedTour": "Partial withdrawal",
    "ChangeedTour": "Partial change",
    "AllAmendingFlight": "Refunding",
    "AllChangeingFlight": "Changing",
    "AllBookingFlight": "Booking",
    "AllAmendingTrain": "Refunding",
    "AllChangeingTrain": "Changing",
    "AllBookingTrain": "Booking",
    "AllAmendingHotel": "Refunding",
    "AllChangeingHotel": "Changing",
    "AllBookingHotel": "Booking",
    "AllAmendingTour": "Withdraw from the group",
    "AllChangeingTour": "Changing",
    "AllBookingTour": "Booking",
    "AllAmendedFlight": "Refund successfully",
    "AllChangeedFlight": "Change successfully",
    "AllBookedFlight": "Purchase successfully",
    "AllAmendedTrain": "Refund successfully",
    "AllChangeedTrain": "Change successfully",
    "AllBookedTrain": "Purchase successfully",
    "AllAmendedHotel": "Refund successfully",
    "AllChangeedHotel": "Change successfully",
    "AllBookedHotel": "Purchase successfully",
    "AllAmendedTour": "Successful withdrawal",
    "AllChangeedTour": "Change successfully",
    "AllBookedTour": "Purchase successfully"
  },
  "RegExp": {
    "AccountReg": {
      "isEmpty": "Account name cannot be empty",
      "isFormat": "Incorrect account format"
    },
    "PwdReg": {
      "isEmpty": "Password cannot be empty",
      "isFormat": "Incorrect password format"
    },
    "ConfigPwd": {
      "isEmpty": "Password cannot be empty",
      "isFormat": "Passwords does not match!"
    },
    "VerificationCodeReg": { "isEmpty": "Verification code cannot be empty" },
    "DynamicCodeReg": { "isEmpty": "Dynamic code cannot be empty" },
    "ProtocolReg": { "isFlag": "Must comply with the agreement" }
  }
}
